/** Auto-generated unified FAQ: one layout template + VI/EN texts. Do not edit template classes in two places. */
const faqItems = [
  {
    "category": "legal",
    "number": "1",
    "question": {
      "vi": "Từ ngày 01/07/2026, doanh nghiệp có bắt buộc phải chuyển toàn bộ sang hợp đồng lao động điện tử không?",
      "en": "From 1 July 2026, are enterprises required to switch entirely to electronic employment contracts?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<p>3<strong>4</strong>5</p>\n<blockquote>6</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">7</a>\n<p>8<strong>9</strong>10</p>\n<p>11</p>\n<blockquote>12</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">13</a>\n<h3>14</h3>\n<p>15</p>\n<ul>\n<li><strong>16</strong>17</li>\n<li><strong>18</strong>19</li>\n</ul>\n\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">20</div>\n<h3>21</h3>\n<ul>\n<li>22</li>\n<li>23</li>\n<li>24</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không.",
        " Pháp luật không bắt buộc mọi doanh nghiệp phải bỏ hợp đồng giấy và chuyển toàn bộ sang hợp đồng điện tử.",
        "Khoản 3 Điều 4 Nghị định 337/2025/NĐ-CP sử dụng từ ",
        "“khuyến khích”",
        ", không sử dụng từ “bắt buộc”:",
        "“Khuyến khích sử dụng hợp đồng lao động điện tử thay thế cho hợp đồng lao động bằng văn bản giấy...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Tuy nhiên, khi doanh nghiệp ",
        "đã lựa chọn giao kết hợp đồng lao động điện tử",
        ", kể từ ngày 01/07/2026, hợp đồng sau khi giao kết phải được gửi về Nền tảng hợp đồng lao động điện tử để cấp ID.",
        "Khoản 1 Điều 24 Thông tư 08/2026/TT-BNV quy định:",
        "“Hợp đồng lao động điện tử sau khi giao kết phải được gửi về Nền tảng... để thực hiện cấp ID.”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Doanh nghiệp cần lưu ý",
        "Có hai tầng nghĩa khác nhau:",
        "Lựa chọn ký giấy hay ký điện tử:",
        " doanh nghiệp được lựa chọn.",
        "Đã chọn ký điện tử:",
        " phải tuân thủ quy trình ký số, dấu thời gian, chứng thực thông điệp dữ liệu, truyền dữ liệu và cấp ID.",
        "Giải pháp GoPaperless",
        "Triển khai từng bước, không buộc doanh nghiệp phải thay đổi toàn bộ ngay lập tức",
        "Có thể thí điểm theo một đơn vị, chi nhánh, nhóm nhân sự mới hoặc một loại hợp đồng trước khi mở rộng.",
        "Hỗ trợ tổ chức quy trình từ khởi tạo dữ liệu, phê duyệt, ký số, lưu hồ sơ đến theo dõi việc gửi và nhận ID theo phạm vi kết nối được triển khai.",
        "Cho phép doanh nghiệp duy trì song song quy trình giấy và điện tử trong giai đoạn chuyển đổi, đồng thời đo lường thời gian, chi phí và tỷ lệ hoàn tất."
      ],
      "en": [
        "Short answer",
        "No.",
        " The law does not require every enterprise to abandon paper contracts and convert all employment contracts into electronic form.",
        "Clause 3 Article 4 of Decree No. 337/2025/ND-CP uses the word ",
        "“encouraged”",
        ", not “mandatory”:",
        "“The use of electronic employment contracts to replace paper-form employment contracts is encouraged...”",
        "Source: Decree No. 337/2025/ND-CP",
        "However, once an enterprise ",
        "chooses to conclude an electronic employment contract",
        ", from 1 July 2026 the concluded contract must be sent to the Electronic Employment Contract Platform for ID issuance.",
        "Clause 1 Article 24 of Circular No. 08/2026/TT-BNV provides:",
        "“After an electronic employment contract is concluded, it must be sent to the Platform... for ID issuance.”",
        "Source: Circular No. 08/2026/TT-BNV",
        "What enterprises should note",
        "There are two distinct issues:",
        "Choosing paper or electronic execution:",
        " the enterprise may choose either form.",
        "Having chosen electronic execution:",
        " the enterprise must comply with the process for digital signatures, timestamps, data-message authentication, data transmission and ID issuance.",
        "GoPaperless solution",
        "A phased rollout without forcing an immediate enterprise-wide change",
        "Pilot the solution in one business unit, branch, newly hired employee group or contract type before expanding.",
        "Support the process from data initiation, approval and digital signing to record retention and monitoring the submission and receipt of IDs, within the implemented connection scope.",
        "Allow paper and electronic processes to operate in parallel during the transition while measuring processing time, cost and completion rates."
      ]
    }
  },
  {
    "category": "legal",
    "number": "2",
    "question": {
      "vi": "Hợp đồng lao động điện tử có giá trị pháp lý như hợp đồng giấy không?",
      "en": "Does an electronic employment contract have the same legal validity as a paper contract?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<p>3</p>\n<blockquote>4</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">5</a>\n<p>6</p>\n<p>7</p>\n<blockquote>8</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2023/8/luat20-2023-qh15..pdf\" rel=\"noopener\" target=\"_blank\">9</a>\n<h3>10</h3>\n<p>11</p>\n<ul>\n<li><strong>12</strong>13</li>\n<li><strong>14</strong>15</li>\n<li><strong>16</strong>17</li>\n<li><strong>18</strong>19</li>\n</ul>\n<p>20<strong>21</strong>22</p>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">23</div>\n<h3>24</h3>\n<ul>\n<li>25</li>\n<li>26</li>\n<li>27</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có",
        ", nếu hợp đồng được giao kết và thực hiện đúng các điều kiện của pháp luật về lao động và giao dịch điện tử.",
        "Khoản 1 Điều 3 Nghị định 337/2025/NĐ-CP định nghĩa hợp đồng lao động điện tử và khẳng định:",
        "“Có giá trị pháp lý như hợp đồng lao động bằng văn bản giấy.”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Tuy nhiên, “có giá trị pháp lý như hợp đồng giấy” không đồng nghĩa rằng bất kỳ file điện tử nào cũng đương nhiên trở thành chứng cứ tuyệt đối.",
        "Khoản 2 Điều 11 Luật Giao dịch điện tử 2023 yêu cầu đánh giá:",
        "“Độ tin cậy... tính toàn vẹn... cách thức xác định người khởi tạo, gửi, nhận...”",
        "Nguồn: Luật Giao dịch điện tử 2023",
        "Doanh nghiệp cần lưu ý",
        "Cần phân biệt:",
        "Giá trị pháp lý:",
        " pháp luật công nhận hình thức điện tử.",
        "Giá trị chứng minh:",
        " phụ thuộc vào khả năng xác định đúng người ký, đúng thời điểm, đúng phiên bản tài liệu và lịch sử giao dịch.",
        "Nội dung hợp pháp:",
        " các điều khoản về lương, công việc, thời hạn, quyền và nghĩa vụ vẫn phải đúng pháp luật lao động.",
        "Thẩm quyền:",
        " đúng người ký số nhưng không có thẩm quyền đại diện thì vẫn phát sinh rủi ro.",
        "Vì vậy, giá trị của giải pháp eContract không nằm riêng ở file PDF, mà nằm ở ",
        "toàn bộ hồ sơ bằng chứng đi kèm file PDF",
        ".",
        "Giải pháp GoPaperless",
        "Không chỉ tạo một file PDF, mà tạo cả hồ sơ bằng chứng của giao dịch",
        "Quản lý người ký, vai trò, thứ tự ký và phiên bản tài liệu được các bên tiếp nhận.",
        "Hỗ trợ chữ ký số, thông tin chứng thư, dấu thời gian, xác thực chủ thể và nhật ký giao dịch theo cấu hình dịch vụ.",
        "Cho phép tìm kiếm, tải xuống và chuẩn bị hồ sơ phục vụ kiểm tra, thanh tra hoặc giải quyết tranh chấp."
      ],
      "en": [
        "Short answer",
        "Yes",
        ", provided that the contract is concluded and performed in accordance with the applicable employment and electronic-transactions laws.",
        "Clause 1 Article 3 of Decree No. 337/2025/ND-CP defines an electronic employment contract and confirms that it:",
        "“Has the same legal validity as a paper-form employment contract.”",
        "Source: Decree No. 337/2025/ND-CP",
        "However, “having the same legal validity as a paper contract” does not mean that every electronic file automatically constitutes conclusive evidence.",
        "Clause 2 Article 11 of the 2023 Law on Electronic Transactions requires consideration of:",
        "“Reliability... integrity... the method used to identify the originator, sender and recipient...”",
        "Source: 2023 Law on Electronic Transactions",
        "What enterprises should note",
        "The following concepts must be distinguished:",
        "Legal validity:",
        " the law recognizes the electronic form.",
        "Evidentiary value:",
        " this depends on the ability to identify the correct signer, signing time, document version and transaction history.",
        "Lawful content:",
        " provisions on salary, work, term, rights and obligations must still comply with employment law.",
        "Authority:",
        " even a valid digital signature may create risk if the signer lacks authority to represent the relevant party.",
        "Therefore, the value of an eContract solution does not lie in the PDF alone, but in ",
        "the complete evidence package accompanying that PDF",
        ".",
        "GoPaperless solution",
        "More than a PDF: a complete transaction evidence package",
        "Manage signers, roles, signing order and the document version received by each party.",
        "Support digital signatures, certificate information, timestamps, identity authentication and transaction logs according to the service configuration.",
        "Enable searching, downloading and preparation of records for inspection, audit or dispute resolution."
      ]
    }
  },
  {
    "category": "legal",
    "number": "3",
    "question": {
      "vi": "Hợp đồng giấy ký tay rồi scan thành PDF có phải là hợp đồng lao động điện tử không?",
      "en": "Is a hand-signed paper contract scanned into a PDF considered an electronic employment contract?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong></p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2023/8/luat20-2023-qh15..pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<ul>\n<li>6</li>\n<li>7</li>\n<li>8</li>\n</ul>\n<p>9</p>\n<ul>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n<li>13</li>\n</ul>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">14</a>\n<h3>15</h3>\n<p>16</p>\n<ol>\n<li><strong>17</strong>18</li>\n<li><strong>19</strong>20</li>\n<li><strong>21</strong>22</li>\n</ol>\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">23</div>\n<h3>24</h3>\n<ul>\n<li>25</li>\n<li>26</li>\n<li>27</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không tự động được xem là hợp đồng lao động điện tử hợp lệ chỉ vì đã được scan thành PDF.",
        "Điểm a khoản 1 Điều 12 Luật Giao dịch điện tử 2023 yêu cầu đối với tài liệu được chuyển đổi:",
        "“Thông tin trong thông điệp dữ liệu được bảo đảm toàn vẹn như văn bản giấy.”",
        "Nguồn: Luật Giao dịch điện tử 2023",
        "Ngoài tính toàn vẹn, Điều 12 còn yêu cầu tài liệu phải:",
        "Có thể truy cập, sử dụng để tham chiếu.",
        "Có ký hiệu xác nhận đã được chuyển đổi.",
        "Có thông tin về tổ chức hoặc cá nhân thực hiện chuyển đổi.",
        "Riêng với hợp đồng lao động, khoản 1 Điều 8 Nghị định 337/2025/NĐ-CP còn yêu cầu:",
        "Chủ thể giao kết hợp đồng giấy phải được xác thực.",
        "Bản chuyển đổi phải được người có thẩm quyền của người sử dụng lao động ký số.",
        "Người ký số phải xác nhận tính chính xác, đầy đủ so với bản gốc.",
        "Sau khi chuyển đổi, hợp đồng phải được gắn ID.",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Doanh nghiệp cần lưu ý",
        "Ba trường hợp cần phân biệt:",
        "Scan để lưu nội bộ:",
        " chỉ là bản sao hình ảnh.",
        "Scan rồi gửi email:",
        " vẫn chưa đáp ứng đầy đủ quy trình chuyển đổi.",
        "Chuyển đổi hợp lệ:",
        " phải có xác thực, nhật ký chuyển đổi, kiểm tra toàn vẹn, ký số của người có thẩm quyền và cấp ID.",
        "Giải pháp GoPaperless",
        "Hỗ trợ số hóa kho hợp đồng cũ theo quy trình có kiểm soát",
        "Phân loại bản scan, gắn thông tin nguồn, người lao động, thời hạn và tình trạng hiệu lực.",
        "Thiết lập luồng kiểm tra, xác nhận của người có thẩm quyền và lưu vết quá trình chuyển đổi.",
        "Hỗ trợ chuẩn bị dữ liệu để gửi cấp ID khi hồ sơ đáp ứng điều kiện; hệ thống không tự biến một bản scan thiếu căn cứ thành hợp đồng hợp lệ."
      ],
      "en": [
        "Short answer",
        "It is not automatically considered a valid electronic employment contract merely because it has been scanned into a PDF.",
        "Point a Clause 1 Article 12 of the 2023 Law on Electronic Transactions requires a converted document to satisfy the following condition:",
        "“The information in the data message is assured to have the same integrity as the paper document.”",
        "Source: 2023 Law on Electronic Transactions",
        "In addition to integrity, Article 12 requires the document to:",
        "Remain accessible and usable for reference.",
        "Contain an indication confirming that it has been converted.",
        "Contain information about the organization or individual that performed the conversion.",
        "For employment contracts specifically, Clause 1 Article 8 of Decree No. 337/2025/ND-CP also requires that:",
        "The parties to the paper contract be authenticated.",
        "The converted version be digitally signed by an authorized representative of the employer.",
        "The digital signer confirm that the converted version is accurate and complete compared with the original.",
        "The contract be assigned an ID after conversion.",
        "Source: Decree No. 337/2025/ND-CP",
        "What enterprises should note",
        "Three situations must be distinguished:",
        "Scanning for internal storage:",
        " this only creates an image copy.",
        "Scanning and sending by email:",
        " this still does not satisfy the full conversion process.",
        "A legally compliant conversion:",
        " this requires authentication, a conversion log, integrity verification, the digital signature of an authorized person and ID issuance.",
        "GoPaperless solution",
        "Controlled digitization of legacy contract archives",
        "Classify scanned documents and associate them with source information, employees, contract terms and validity status.",
        "Establish a review and confirmation workflow for authorized persons and maintain an audit trail of the conversion process.",
        "Prepare data for ID submission when the record meets the relevant conditions; the system does not automatically turn an unsupported scan into a legally compliant contract."
      ]
    }
  },
  {
    "category": "legal",
    "number": "4",
    "question": {
      "vi": "Hợp đồng được cấp ID có đồng nghĩa hợp pháp 100% không?",
      "en": "Does receiving an ID mean that a contract is 100% legally compliant?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<p>3</p>\n<blockquote>4</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">5</a>\n<p>6</p>\n<h3>7</h3>\n<p>8</p>\n<ul>\n<li>9</li>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n</ul>\n<p>13</p>\n<ul>\n<li>14</li>\n<li>15</li>\n<li>16</li>\n<li>17</li>\n<li>18</li>\n</ul>\n\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">19</div>\n<h3>20</h3>\n<ul>\n<li>21</li>\n<li>22</li>\n<li>23</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không.",
        " ID không phải là giấy chứng nhận rằng mọi nội dung và mọi chủ thể của hợp đồng đều hợp pháp tuyệt đối.",
        "Khoản 3 Điều 4 Thông tư 08/2026/TT-BNV quy định rất rõ:",
        "“Việc cấp ID... không làm thay đổi thời điểm giao kết, nội dung, thời điểm có hiệu lực...”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "ID được cơ quan nhà nước sử dụng làm mã quản lý dữ liệu số đối với hợp đồng lao động điện tử.",
        "Doanh nghiệp cần lưu ý",
        "ID giúp:",
        "Nhận diện duy nhất một hợp đồng.",
        "Liên kết hợp đồng với phụ lục, tạm hoãn và chấm dứt.",
        "Hỗ trợ quản lý, tra cứu và truy xuất lịch sử.",
        "Xác nhận hồ sơ đã vượt qua bước kiểm tra dữ liệu để được Nền tảng cấp mã.",
        "ID không tự động xác nhận rằng:",
        "Người đại diện doanh nghiệp chắc chắn có đúng thẩm quyền.",
        "Mọi điều khoản trong hợp đồng đều phù hợp Bộ luật Lao động.",
        "Không có sự ép buộc hoặc giả mạo.",
        "Hợp đồng không thể bị tranh chấp.",
        "Hợp đồng chắc chắn được Tòa án chấp nhận theo toàn bộ yêu cầu của một bên.",
        "Giải pháp GoPaperless",
        "Tách rõ trạng thái pháp lý của giao dịch và trạng thái cấp ID",
        "Theo dõi riêng các mốc: đã ký đủ bên, đã chứng thực, đã gửi Nền tảng, đang xử lý, đã cấp ID hoặc bị trả lỗi.",
        "Lưu ID cùng hợp đồng và liên kết với phụ lục, tạm hoãn, chấm dứt để quản lý xuyên suốt vòng đời.",
        "Duy trì toàn bộ bằng chứng giao kết thay vì chỉ dựa vào một mã ID."
      ],
      "en": [
        "Short answer",
        "No.",
        " An ID is not a certificate confirming that every provision and every party to the contract is unquestionably lawful.",
        "Clause 3 Article 4 of Circular No. 08/2026/TT-BNV states clearly:",
        "“The issuance of an ID... does not alter the time of conclusion, the contents or the effective date...”",
        "Source: Circular No. 08/2026/TT-BNV",
        "The ID is used by the competent state authority as a digital-data management code for an electronic employment contract.",
        "What enterprises should note",
        "An ID helps to:",
        "Uniquely identify a contract.",
        "Link the contract to appendices, suspension agreements and termination documents.",
        "Support management, searches and historical traceability.",
        "Confirm that the submitted record passed the Platform's data checks for code issuance.",
        "An ID does not automatically confirm that:",
        "The enterprise representative unquestionably had proper authority.",
        "Every contractual provision complies with the Labor Code.",
        "No coercion or impersonation occurred.",
        "The contract cannot be disputed.",
        "A court will necessarily accept every claim made by one party.",
        "GoPaperless solution",
        "Separate the transaction's legal status from its ID-issuance status",
        "Track distinct milestones: all parties signed, authenticated, submitted to the Platform, under processing, assigned an ID or returned with an error.",
        "Store the ID with the contract and link it to appendices, suspension and termination records throughout the contract lifecycle.",
        "Preserve the full set of conclusion evidence rather than relying on an ID alone."
      ]
    }
  },
  {
    "category": "legal",
    "number": "5",
    "question": {
      "vi": "Hợp đồng điện tử có hiệu lực khi ký xong hay khi được cấp ID?",
      "en": "Does an electronic contract take effect when signing is completed or when an ID is issued?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1<strong>2</strong>3</p>\n<p>4</p>\n<blockquote>5</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">6</a>\n<p>7</p>\n<ul>\n<li>8</li>\n<li>9</li>\n<li>10</li>\n</ul>\n<h3>11</h3>\n<p>12</p>\n<ol>\n<li>13</li>\n<li>14</li>\n<li>15</li>\n<li>16</li>\n</ol>\n<p>17</p>\n<ul>\n<li>18</li>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n<li>22</li>\n<li>23</li>\n</ul>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">24</div>\n<h3>25</h3>\n<ul>\n<li>26</li>\n<li>27</li>\n<li>28</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Thông thường, hợp đồng có hiệu lực từ thời điểm ",
        "bên sau cùng hoàn tất ký số cùng các thành phần pháp lý liên quan",
        ", không phải chờ đến thời điểm được cấp ID.",
        "Điều 7 Nghị định 337/2025/NĐ-CP quy định:",
        "“Hợp đồng lao động điện tử có hiệu lực kể từ thời điểm bên sau cùng ký số...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Điều luật đồng thời yêu cầu:",
        "Dấu thời gian gắn kèm chữ ký số của các chủ thể.",
        "Chứng thực thông điệp dữ liệu của nhà cung cấp eContract.",
        "Trừ trường hợp các bên có thỏa thuận khác.",
        "Doanh nghiệp cần lưu ý",
        "Cần quản lý riêng ít nhất bốn mốc:",
        "Thời điểm người sử dụng lao động ký.",
        "Thời điểm người lao động ký.",
        "Thời điểm hợp đồng phát sinh hiệu lực.",
        "Thời điểm Nền tảng cấp ID.",
        "Một hệ thống phù hợp cần thể hiện nhiều hơn hai trạng thái “chưa ký” và “đã ký”, bao gồm:",
        "Đã ký đủ các bên.",
        "Đã chứng thực.",
        "Đã gửi Nền tảng.",
        "Đang chờ cấp ID.",
        "Đã cấp ID.",
        "Bị từ chối cấp ID và lý do.",
        "Giải pháp GoPaperless",
        "Hiển thị đầy đủ các mốc thay vì chỉ có “chưa ký” và “đã ký”",
        "Ghi nhận thời điểm từng bên ký, thời điểm hoàn tất, thời điểm gửi, tiếp nhận và cấp ID.",
        "Cảnh báo hồ sơ quá hạn, hồ sơ chưa hoàn tất hoặc phát sinh lỗi trong từng công đoạn.",
        "Cho phép HR và bộ phận pháp chế tra cứu lịch sử theo từng hợp đồng mà không phải tổng hợp thủ công từ email và tin nhắn."
      ],
      "en": [
        "Short answer",
        "As a general rule, the contract takes effect when the last party completes the digital signing process together with the required legal components, ",
        "not when the ID is issued",
        ".",
        "Article 7 of Decree No. 337/2025/ND-CP provides:",
        "“An electronic employment contract takes effect from the time the last party digitally signs...”",
        "Source: Decree No. 337/2025/ND-CP",
        "The provision also requires:",
        "A timestamp associated with each party's digital signature.",
        "Authentication of the data message by the eContract service provider.",
        "Except where the parties agree otherwise.",
        "What enterprises should note",
        "At least four milestones should be managed separately:",
        "The time the employer signs.",
        "The time the employee signs.",
        "The time the contract becomes effective.",
        "The time the Platform issues the ID.",
        "A suitable system should display more than the two statuses “unsigned” and “signed”, including:",
        "Signed by all parties.",
        "Authenticated.",
        "Submitted to the Platform.",
        "Awaiting ID issuance.",
        "ID issued.",
        "ID issuance rejected, together with the reason.",
        "GoPaperless solution",
        "Display every milestone, not merely “unsigned” and “signed”",
        "Record when each party signs, when signing is completed, and when the record is submitted, received and assigned an ID.",
        "Warn of overdue records, incomplete records or errors arising at each stage.",
        "Allow HR and legal teams to review the history of each contract without manually consolidating emails and messages."
      ]
    }
  },
  {
    "category": "legal",
    "number": "6",
    "question": {
      "vi": "VNeID có phải là chữ ký số không?",
      "en": "Is VNeID a digital signature?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong></p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<blockquote>6</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">7</a>\n<h3>8</h3>\n<p>9</p>\n<ul>\n<li><strong>10</strong>11</li>\n<li><strong>12</strong>13</li>\n<li><strong>14</strong>15</li>\n</ul>\n<p>16</p>\n\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">17</div>\n<h3>18</h3>\n<ul>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "VNeID và chữ ký số là hai khái niệm khác nhau.",
        "Thông tư 08/2026/TT-BNV quy định sử dụng tài khoản định danh điện tử do:",
        "“VNeID cấp... để đăng nhập Nền tảng hợp đồng lao động điện tử.”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Trong khi đó, điểm c khoản 2 Điều 6 Nghị định 337/2025/NĐ-CP yêu cầu các bên:",
        "“Có chữ ký số và sử dụng dịch vụ cấp dấu thời gian...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Doanh nghiệp cần lưu ý",
        "Có thể hình dung thành ba lớp:",
        "VNeID:",
        " giúp xác định và xác thực người đang thực hiện giao dịch.",
        "Chữ ký số:",
        " ghi nhận hành vi ký và sự chấp thuận của chủ thể đối với nội dung.",
        "Dấu thời gian:",
        " xác định chữ ký và thông điệp dữ liệu đã tồn tại tại một thời điểm cụ thể.",
        "Một giải pháp có thể tích hợp các lớp này thành một trải nghiệm liền mạch trên điện thoại. Tuy nhiên, về mặt pháp lý và kỹ thuật, không nên nói đơn giản:",
        "Giải pháp GoPaperless",
        "Kết hợp định danh VNeID với quy trình ký số, nhưng không đánh đồng hai lớp",
        "GoPaperless Agent hỗ trợ tích hợp VNeID và kết nối các nhà cung cấp chữ ký số từ xa được cấp phép.",
        "Quy trình có thể tách rõ bước xác thực danh tính, bước xem và đồng ý nội dung, bước ký số và bước gắn dấu thời gian.",
        "Doanh nghiệp có thể kiểm tra lại thông tin người ký và chứng thư thay vì chỉ nhìn vào việc người dùng đã đăng nhập."
      ],
      "en": [
        "Short answer",
        "VNeID and a digital signature are two different concepts.",
        "Circular No. 08/2026/TT-BNV provides for the use of an electronic identification account issued through:",
        "“VNeID... to log in to the Electronic Employment Contract Platform.”",
        "Source: Circular No. 08/2026/TT-BNV",
        "By contrast, Point c Clause 2 Article 6 of Decree No. 337/2025/ND-CP requires the parties to:",
        "“Have digital signatures and use a timestamping service...”",
        "Source: Decree No. 337/2025/ND-CP",
        "What enterprises should note",
        "The process can be understood as three layers:",
        "VNeID:",
        " identifies and authenticates the person performing the transaction.",
        "Digital signature:",
        " records the act of signing and the signer's consent to the contents.",
        "Timestamp:",
        " establishes that the signature and data message existed at a specific time.",
        "A solution may integrate these layers into a seamless mobile experience. Legally and technically, however, logging in or authenticating through VNeID must not be equated with applying a digital signature.",
        "GoPaperless solution",
        "Combine VNeID identification with digital signing without conflating the two layers",
        "GoPaperless Agent supports VNeID integration and connections to licensed remote digital-signature providers.",
        "The workflow can clearly separate identity authentication, review and acceptance of content, digital signing and timestamping.",
        "The enterprise can verify signer and certificate information rather than relying solely on the fact that the user logged in."
      ]
    }
  },
  {
    "category": "legal",
    "number": "7",
    "question": {
      "vi": "Chỉ nhập mã OTP là đã đủ điều kiện ký hợp đồng lao động điện tử chưa?",
      "en": "Is entering an OTP alone sufficient to sign an electronic employment contract?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong></p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<ul>\n<li>6</li>\n<li>7</li>\n<li>8</li>\n<li>9</li>\n</ul>\n<h3>10</h3>\n<p>11</p>\n<ul>\n<li>12</li>\n<li>13</li>\n<li>14</li>\n</ul>\n<p>15</p>\n<ul>\n<li>16</li>\n<li>17</li>\n<li>18</li>\n<li>19</li>\n<li>20</li>\n</ul>\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">21</div>\n<h3>22</h3>\n<ul>\n<li>23</li>\n<li>24</li>\n<li>25</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "OTP một mình chưa đủ để đáp ứng toàn bộ quy trình giao kết hợp đồng lao động điện tử theo Nghị định 337.",
        "Nghị định yêu cầu người lao động và người sử dụng lao động:",
        "“Có chữ ký số và sử dụng dịch vụ cấp dấu thời gian...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Khoản 4 Điều 6 còn yêu cầu hợp đồng phải có:",
        "Xác thực định danh chủ thể.",
        "Chữ ký số.",
        "Dấu thời gian gắn với chữ ký số.",
        "Chứng thực thông điệp dữ liệu của nhà cung cấp eContract.",
        "Doanh nghiệp cần lưu ý",
        "OTP có thể được sử dụng như:",
        "Một yếu tố xác thực.",
        "Một bước ghi nhận đồng ý.",
        "Một lớp bảo vệ trong quy trình ký.",
        "Nhưng OTP không tự động thay thế:",
        "Chữ ký số.",
        "Dấu thời gian.",
        "Chứng thực thông điệp dữ liệu.",
        "Hồ sơ xác thực chủ thể.",
        "Nhật ký giao dịch.",
        "Giải pháp GoPaperless",
        "OTP được sử dụng đúng vai trò, không thay thế toàn bộ bằng chứng pháp lý",
        "Có thể dùng OTP như một lớp xác thực hoặc xác nhận trong luồng giao dịch.",
        "Hồ sơ hoàn chỉnh vẫn được tổ chức cùng chữ ký số, dấu thời gian, chứng thực thông điệp dữ liệu và nhật ký giao dịch theo mô hình triển khai.",
        "Người quản trị có thể kiểm tra phương thức xác thực và phương thức ký đã áp dụng cho từng hồ sơ."
      ],
      "en": [
        "Short answer",
        "An OTP alone is not sufficient to satisfy the entire electronic employment contract conclusion process under Decree No. 337.",
        "The Decree requires employees and employers to:",
        "“Have digital signatures and use a timestamping service...”",
        "Source: Decree No. 337/2025/ND-CP",
        "Clause 4 Article 6 also requires the contract process to include:",
        "Authentication of the parties' identities.",
        "Digital signatures.",
        "Timestamps associated with the digital signatures.",
        "Data-message authentication by the eContract service provider.",
        "What enterprises should note",
        "An OTP may be used as:",
        "An authentication factor.",
        "A step for recording consent.",
        "A security layer in the signing workflow.",
        "However, an OTP does not automatically replace:",
        "A digital signature.",
        "A timestamp.",
        "Data-message authentication.",
        "Identity-authentication records.",
        "Transaction logs.",
        "GoPaperless solution",
        "Use OTP for its proper purpose, not as a substitute for the complete legal evidence package",
        "Use OTP as an authentication or confirmation layer within the transaction workflow.",
        "Organize the completed record together with digital signatures, timestamps, data-message authentication and transaction logs according to the deployment model.",
        "Allow administrators to verify the authentication method and signing method applied to each record."
      ]
    }
  },
  {
    "category": "operation",
    "number": "8",
    "question": {
      "vi": "Người lao động có bắt buộc phải được nhận một bản hợp đồng điện tử không?",
      "en": "Must the employee receive a copy of the electronic employment contract?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<p>3</p>\n<blockquote>4</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">5</a>\n<p>6</p>\n<p>7</p>\n<h3>8</h3>\n<p>9</p>\n<ul>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n<li>13</li>\n<li>14</li>\n</ul>\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">15</div>\n<h3>16</h3>\n<ul>\n<li>17</li>\n<li>18</li>\n<li>19</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có.",
        " Hợp đồng phải được gửi cho cả người lao động và người sử dụng lao động.",
        "Khoản 2 Điều 4 Nghị định 337/2025/NĐ-CP quy định:",
        "“Phải được gửi cho người lao động và người sử dụng lao động...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Việc gửi được thực hiện dưới hình thức thông điệp dữ liệu, thông qua phương tiện điện tử phù hợp theo thỏa thuận của các bên.",
        "Ngoài ra, khoản 1 Điều 21 Nghị định 337 yêu cầu nhà cung cấp eContract gửi bản hợp đồng có gắn ID cho cả hai bên.",
        "Doanh nghiệp cần lưu ý",
        "Người lao động không nên bị phụ thuộc hoàn toàn vào tài khoản nội bộ của doanh nghiệp. Giải pháp nên bảo đảm người lao động có thể:",
        "Nhận hợp đồng qua phương tiện đã thỏa thuận.",
        "Tải xuống bản hoàn chỉnh.",
        "Lưu bản hợp đồng độc lập.",
        "Kiểm tra chữ ký, ID và thông tin liên quan.",
        "Tiếp tục truy cập hồ sơ hợp pháp sau khi nghỉ việc.",
        "Giải pháp GoPaperless",
        "Người lao động được nhận và lưu bản hợp đồng của mình",
        "Hỗ trợ gửi lời mời và tài liệu qua phương tiện điện tử đã thỏa thuận, bao gồm mô hình ký không cần tạo tài khoản GoPaperless.",
        "Sau khi hoàn tất, người lao động có thể nhận, tải xuống và lưu bản hợp đồng độc lập.",
        "Doanh nghiệp đồng thời lưu hồ sơ tập trung để tra cứu, báo cáo và quản lý vòng đời."
      ],
      "en": [
        "Short answer",
        "Yes.",
        " The contract must be sent to both the employee and the employer.",
        "Clause 2 Article 4 of Decree No. 337/2025/ND-CP provides:",
        "“It must be sent to the employee and the employer...”",
        "Source: Decree No. 337/2025/ND-CP",
        "The contract is sent as a data message through an appropriate electronic means agreed by the parties.",
        "In addition, Clause 1 Article 21 of Decree No. 337 requires the eContract service provider to send the ID-bearing contract to both parties.",
        "What enterprises should note",
        "Employees should not be entirely dependent on an enterprise's internal account. The solution should ensure that an employee can:",
        "Receive the contract through the agreed means.",
        "Download the completed version.",
        "Store an independent copy of the contract.",
        "Verify signatures, the ID and related information.",
        "Continue to access the lawful record after leaving employment.",
        "GoPaperless solution",
        "Employees receive and retain their own contract copy",
        "Support invitations and document delivery through the agreed electronic means, including accountless signing models that do not require a GoPaperless account.",
        "After completion, allow the employee to receive, download and independently store the contract.",
        "At the same time, maintain a centralized enterprise record for searches, reporting and lifecycle management."
      ]
    }
  },
  {
    "category": "operation",
    "number": "9",
    "question": {
      "vi": "Sau khi hai bên ký, doanh nghiệp có thể sửa hợp đồng điện tử không?",
      "en": "After both parties have signed, may the enterprise edit the electronic contract?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong></p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<p>6</p>\n<blockquote>7</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">8</a>\n<h3>9</h3>\n<p>10</p>\n<ul>\n<li><strong>11</strong>12</li>\n<li><strong>13</strong>14</li>\n<li><strong>15</strong>16</li>\n<li><strong>17</strong>18</li>\n<li><strong>19</strong>20</li>\n</ul>\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">21</div>\n<h3>22</h3>\n<ul>\n<li>23</li>\n<li>24</li>\n<li>25</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không được âm thầm ghi đè hoặc sửa nội dung hợp đồng gốc đã ký.",
        "Khoản 2 Điều 15 Thông tư 08/2026/TT-BNV yêu cầu:",
        "“Không được sửa lịch sử giao dịch gốc trái pháp luật.”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Nếu cần thay đổi nội dung, doanh nghiệp phải thực hiện theo quy trình sửa đổi, bổ sung hoặc lập phụ lục.",
        "Khoản 3 Điều 9 Nghị định 337 quy định phụ lục, thỏa thuận tạm hoãn và thông báo chấm dứt:",
        "“Phải được gắn cùng ID của hợp đồng lao động đó...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Doanh nghiệp cần lưu ý",
        "Hệ thống phải phân biệt:",
        "Bản hợp đồng gốc đã ký:",
        " phải được bảo toàn.",
        "Bản dự thảo chưa ký:",
        " có thể chỉnh sửa.",
        "Phụ lục sửa đổi:",
        " là một giao dịch mới, có lịch sử riêng.",
        "Tạm hoãn hoặc chấm dứt:",
        " phải được ghi nhận theo đúng quy trình.",
        "Thay đổi kỹ thuật:",
        " không được làm mất khả năng kiểm tra tính toàn vẹn.",
        "Giải pháp GoPaperless",
        "Bảo toàn bản đã ký và quản lý thay đổi bằng giao dịch mới",
        "Phiên bản hoàn tất được khóa theo cơ chế chữ ký số và kiểm tra tính toàn vẹn.",
        "Phụ lục hoặc nội dung sửa đổi được tạo thành hồ sơ mới, có lịch sử và người ký riêng.",
        "Các văn bản phát sinh được liên kết về hợp đồng gốc và ID tương ứng để tránh thất lạc chuỗi hồ sơ."
      ],
      "en": [
        "Short answer",
        "The enterprise must not silently overwrite or alter the contents of the signed original contract.",
        "Clause 2 Article 15 of Circular No. 08/2026/TT-BNV requires that:",
        "“The original transaction history must not be unlawfully modified.”",
        "Source: Circular No. 08/2026/TT-BNV",
        "If the contents need to be changed, the enterprise must follow the applicable amendment, supplementation or contract-appendix process.",
        "Clause 3 Article 9 of Decree No. 337 provides that appendices, suspension agreements and termination notices:",
        "“Must be associated with the same ID as that employment contract...”",
        "Source: Decree No. 337/2025/ND-CP",
        "What enterprises should note",
        "The system must distinguish between:",
        "The signed original contract:",
        " it must be preserved.",
        "An unsigned draft:",
        " it may be edited.",
        "An amending appendix:",
        " this is a new transaction with its own history.",
        "Suspension or termination:",
        " this must be recorded through the proper process.",
        "Technical changes:",
        " these must not compromise the ability to verify integrity.",
        "GoPaperless solution",
        "Preserve the signed version and manage changes as new transactions",
        "Lock the completed version through digital-signature and integrity-verification mechanisms.",
        "Create each appendix or amendment as a new record with its own history and signers.",
        "Link subsequent documents back to the original contract and corresponding ID so that the record chain remains complete."
      ]
    }
  },
  {
    "category": "operation",
    "number": "10",
    "question": {
      "vi": "Hợp đồng điện tử đã ký trước ngày 01/07/2026 có phải ký lại toàn bộ không?",
      "en": "Must all electronic contracts signed before 1 July 2026 be signed again?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong></p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<blockquote>6</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">7</a>\n<h3>8</h3>\n<p>9</p>\n<ol>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n</ol>\n<p>13</p>\n<ul>\n<li>14</li>\n<li>15</li>\n<li>16</li>\n</ul>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">17</div>\n<h3>18</h3>\n<ul>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không có quy định buộc ký lại hàng loạt tất cả hợp đồng cũ.",
        "Khoản 1 Điều 29 Nghị định 337 quy định hợp đồng được giao kết trước ngày Nghị định có hiệu lực và vẫn còn hiệu lực:",
        "“Được tiếp tục thực hiện... đến hết thời hạn của hợp đồng lao động điện tử.”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Đối với hợp đồng giao kết trước ngày 01/07/2026, điểm c khoản 1 Điều 6 Thông tư 08 yêu cầu nhà cung cấp hỗ trợ:",
        "“Rà soát bổ sung chữ ký số, dấu thời gian... và chứng thực thông điệp dữ liệu...”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Doanh nghiệp cần lưu ý",
        "Doanh nghiệp cần thực hiện ba bước:",
        "Kiểm kê các hợp đồng điện tử đang còn hiệu lực.",
        "Kiểm tra từng hợp đồng đã có đủ chữ ký số, dấu thời gian và chứng thực hay chưa.",
        "Bổ sung những thành phần còn thiếu trước khi gửi để cấp ID.",
        "Doanh nghiệp không cần mặc định rằng:",
        "Tất cả người lao động phải ký lại từ đầu.",
        "Hợp đồng cũ tự động mất hiệu lực.",
        "Chỉ cần tải file cũ lên là chắc chắn được cấp ID.",
        "Giải pháp GoPaperless",
        "Rà soát theo khoảng cách tuân thủ thay vì yêu cầu ký lại hàng loạt",
        "Kiểm kê hợp đồng còn hiệu lực và phân loại theo tình trạng chữ ký số, dấu thời gian, chứng thực và dữ liệu định danh.",
        "Nhập dữ liệu theo lô và lập danh sách hồ sơ cần bổ sung, hồ sơ đủ điều kiện hoặc hồ sơ cần xử lý riêng.",
        "Giảm nguy cơ yêu cầu người lao động ký lại không cần thiết và giúp doanh nghiệp có lộ trình chuyển đổi rõ ràng."
      ],
      "en": [
        "Short answer",
        "There is no requirement to have every existing contract re-signed in bulk.",
        "Clause 1 Article 29 of Decree No. 337 provides that a contract concluded before the Decree's effective date and still in force:",
        "“May continue to be performed... until the electronic employment contract expires.”",
        "Source: Decree No. 337/2025/ND-CP",
        "For contracts concluded before 1 July 2026, Point c Clause 1 Article 6 of Circular No. 08 requires the provider to support:",
        "“Reviewing and supplementing digital signatures, timestamps... and data-message authentication...”",
        "Source: Circular No. 08/2026/TT-BNV",
        "What enterprises should note",
        "The enterprise should take three steps:",
        "Inventory all electronic contracts that remain in force.",
        "Check whether each contract already contains the required digital signatures, timestamps and authentication.",
        "Add any missing components before submitting the contract for ID issuance.",
        "The enterprise should not assume that:",
        "Every employee must sign again from the beginning.",
        "Existing contracts automatically become invalid.",
        "Uploading an old file guarantees ID issuance.",
        "GoPaperless solution",
        "Review compliance gaps instead of requiring mass re-signing",
        "Inventory contracts still in force and classify them according to the status of digital signatures, timestamps, authentication and identity data.",
        "Import data in batches and identify records that need supplementation, are eligible for processing or require separate handling.",
        "Reduce unnecessary re-signing and provide the enterprise with a clear transition roadmap."
      ]
    }
  },
  {
    "category": "operation",
    "number": "11",
    "question": {
      "vi": "Mốc 24 giờ được tính như thế nào?",
      "en": "How are the 24-hour time limits calculated?"
    },
    "answerTemplate": "<p>0<strong>1</strong>2</p>\n<h3>3</h3>\n<p>4</p>\n<blockquote>5</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">6</a>\n<p>7</p>\n<h3>8</h3>\n<p>9</p>\n<blockquote>10</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">11</a>\n<h3>12</h3>\n<p>13</p>\n<ul>\n<li>14</li>\n<li>15</li>\n<li>16</li>\n</ul>\n<p>17</p>\n<p>18</p>\n<ul>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n<li>22</li>\n<li>23</li>\n<li>24</li>\n</ul>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">25</div>\n<h3>26</h3>\n<ul>\n<li>27</li>\n<li>28</li>\n<li>29</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Có ",
        "hai mốc 24 giờ khác nhau",
        ".",
        "Mốc thứ nhất: Nhà cung cấp gửi hợp đồng lên Nền tảng",
        "Khoản 4 Điều 6 Nghị định 337 quy định:",
        "“Trong vòng 24 giờ kể từ thời điểm bên sau cùng ký...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Trong khoảng thời gian này, nhà cung cấp eContract phải gửi hợp đồng về Nền tảng để gắn ID.",
        "Mốc thứ hai: Nền tảng kiểm tra và cấp ID",
        "Khoản 2 Điều 6 Thông tư 08 quy định Nền tảng thực hiện cấp ID:",
        "“Trong vòng 24 giờ kể từ thời điểm tiếp nhận.”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Doanh nghiệp cần lưu ý",
        "Ví dụ:",
        "10 giờ sáng ngày 01: bên sau cùng hoàn thành ký.",
        "Chậm nhất 10 giờ sáng ngày 02: nhà cung cấp phải gửi hồ sơ lên Nền tảng.",
        "Khi Nền tảng tiếp nhận hồ sơ, một khoảng thời gian 24 giờ mới bắt đầu để kiểm tra và cấp ID.",
        "Nếu xảy ra sự cố kỹ thuật trong quá trình đồng bộ, Thông tư 08 cho phép việc cấp ID được thực hiện ngay sau khi sự cố được khắc phục.",
        "Do đó, hệ thống cần lưu riêng:",
        "Thời điểm ký cuối cùng.",
        "Thời điểm gửi.",
        "Thời điểm Nền tảng tiếp nhận.",
        "Thời điểm cấp ID.",
        "Số lần gửi lại.",
        "Nguyên nhân thất bại hoặc chậm xử lý.",
        "Giải pháp GoPaperless",
        "Theo dõi hai đồng hồ 24 giờ trên cùng một màn hình",
        "Ghi nhận thời điểm bên sau cùng ký và hạn gửi hồ sơ lên Nền tảng.",
        "Ghi nhận thời điểm Nền tảng tiếp nhận, thời điểm trả kết quả và ID.",
        "Trong phạm vi kết nối được kích hoạt, hệ thống hỗ trợ cảnh báo, hàng đợi gửi lại, log lỗi và lịch sử xử lý để HR không phải theo dõi thủ công."
      ],
      "en": [
        "There are ",
        "two separate 24-hour time limits",
        ".",
        "First time limit: the provider submits the contract to the Platform",
        "Clause 4 Article 6 of Decree No. 337 provides:",
        "“Within 24 hours from the time the last party signs...”",
        "Source: Decree No. 337/2025/ND-CP",
        "Within this period, the eContract service provider must submit the contract to the Platform for ID assignment.",
        "Second time limit: the Platform checks the record and issues the ID",
        "Clause 2 Article 6 of Circular No. 08 provides that the Platform issues the ID:",
        "“Within 24 hours from the time of receipt.”",
        "Source: Circular No. 08/2026/TT-BNV",
        "What enterprises should note",
        "Example:",
        "At 10:00 a.m. on Day 1, the last party completes signing.",
        "By 10:00 a.m. on Day 2 at the latest, the provider must submit the record to the Platform.",
        "Once the Platform receives the record, a new 24-hour period begins for checking and ID issuance.",
        "If a technical incident occurs during synchronization, Circular No. 08 allows the ID to be issued immediately after the incident is resolved.",
        "The system should therefore separately retain:",
        "The final signing time.",
        "The submission time.",
        "The Platform receipt time.",
        "The ID-issuance time.",
        "The number of resubmission attempts.",
        "The reason for failure or delayed processing.",
        "GoPaperless solution",
        "Monitor both 24-hour clocks on one screen",
        "Record when the last party signs and the deadline for submitting the record to the Platform.",
        "Record when the Platform receives the record, returns a result and issues the ID.",
        "Within the activated connection scope, support alerts, resubmission queues, error logs and processing history so that HR does not need to monitor each record manually."
      ]
    }
  },
  {
    "category": "operation",
    "number": "12",
    "question": {
      "vi": "Hợp đồng bị từ chối cấp ID có tự động vô hiệu không?",
      "en": "Does rejection of ID issuance automatically invalidate the contract?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<p>3</p>\n<blockquote>4</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">5</a>\n<p>6</p>\n<ul>\n<li>7</li>\n<li>8</li>\n<li>9</li>\n<li>10</li>\n</ul>\n<h3>11</h3>\n<p>12</p>\n<ul>\n<li>13</li>\n<li>14</li>\n<li>15</li>\n<li>16</li>\n</ul>\n\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">17</div>\n<h3>18</h3>\n<ul>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Việc bị từ chối cấp ID không tự động đồng nghĩa hợp đồng đã bị tuyên vô hiệu.",
        " Tuy nhiên, việc bị từ chối cho thấy hồ sơ gửi lên chưa đáp ứng một hoặc nhiều điều kiện mà Nền tảng kiểm tra.",
        "Khoản 5 Điều 6 Thông tư 08 quy định Nền tảng:",
        "“Không cấp ID... và tự động gửi thông báo lý do không cấp ID...”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Các nguyên nhân có thể gồm:",
        "Hợp đồng không đáp ứng quy trình tại khoản 4 Điều 6 Nghị định 337.",
        "Bản chuyển đổi từ giấy không đáp ứng Điều 8 Nghị định 337.",
        "Hợp đồng cũ chưa được rà soát, bổ sung thành phần cần thiết.",
        "Thông tin xác thực định danh không đúng.",
        "Doanh nghiệp cần lưu ý",
        "Doanh nghiệp phải xem cụ thể lý do:",
        "Sai dữ liệu có thể sửa và gửi lại.",
        "Thiếu chữ ký số hoặc dấu thời gian cần bổ sung đúng quy trình.",
        "Sai chủ thể hoặc sai thẩm quyền có thể là rủi ro nghiêm trọng hơn.",
        "File không toàn vẹn cần tái lập hồ sơ.",
        "Giải pháp GoPaperless",
        "Biến lỗi cấp ID thành một quy trình xử lý có người chịu trách nhiệm",
        "Hiển thị trạng thái và lý do từ chối theo từng hồ sơ khi dữ liệu phản hồi được cung cấp.",
        "Cho phép phân công xử lý, sửa dữ liệu, bổ sung thành phần còn thiếu và gửi lại theo quy trình.",
        "Lưu nguyên lịch sử hồ sơ cũ và các lần gửi lại để bảo đảm khả năng truy vết."
      ],
      "en": [
        "Short answer",
        "Rejection of ID issuance does not automatically mean that the contract has been declared invalid.",
        " However, it indicates that the submitted record failed to satisfy one or more conditions checked by the Platform.",
        "Clause 5 Article 6 of Circular No. 08 provides that the Platform:",
        "“Does not issue an ID... and automatically sends a notice stating the reason for non-issuance...”",
        "Source: Circular No. 08/2026/TT-BNV",
        "Possible reasons include:",
        "The contract does not comply with the process prescribed in Clause 4 Article 6 of Decree No. 337.",
        "A paper-to-electronic conversion does not comply with Article 8 of Decree No. 337.",
        "An existing contract has not been reviewed and supplemented with the necessary components.",
        "Identity-authentication information is incorrect.",
        "What enterprises should note",
        "The enterprise must review the specific reason:",
        "Incorrect data may be corrected and resubmitted.",
        "Missing digital signatures or timestamps must be added through the proper process.",
        "An incorrect party or lack of authority may present a more serious risk.",
        "A file whose integrity cannot be verified may require the record to be re-created.",
        "GoPaperless solution",
        "Turn ID-issuance errors into an accountable resolution workflow",
        "Display the status and rejection reason for each record when response data is available.",
        "Allow responsibility to be assigned, data to be corrected, missing components to be added and the record to be resubmitted through a controlled process.",
        "Preserve the complete history of the previous record and every resubmission attempt for traceability."
      ]
    }
  },
  {
    "category": "operation",
    "number": "13",
    "question": {
      "vi": "Hợp đồng được lưu trữ trên Nền tảng trong bao lâu?",
      "en": "How long is a contract stored on the Platform?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1<strong>2</strong>3</p>\n<p>4</p>\n<blockquote>5</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">6</a>\n<p>7</p>\n<h3>8</h3>\n\n\n<p>9</p>\n<ul>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n<li>13</li>\n<li>14</li>\n</ul>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">15</div>\n<h3>16</h3>\n<ul>\n<li>17</li>\n<li>18</li>\n<li>19</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Thời hạn lưu trữ là ",
        "10 năm kể từ ngày hợp đồng lao động chấm dứt",
        ".",
        "Khoản 3 Điều 18 Thông tư 08/2026/TT-BNV quy định:",
        "“Là 10 năm kể từ ngày hợp đồng lao động chấm dứt.”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Trường hợp hai bên giao kết nhiều hợp đồng liên tục, thời hạn 10 năm được tính từ ngày chấm dứt hợp đồng cuối cùng.",
        "Doanh nghiệp cần lưu ý",
        "Doanh nghiệp vẫn phải:",
        "Lưu trữ hồ sơ thuộc trách nhiệm của mình.",
        "Bảo đảm tính toàn vẹn.",
        "Bảo đảm khả năng truy xuất.",
        "Có phương án sao lưu và xuất dữ liệu.",
        "Không phụ thuộc hoàn toàn vào một nhà cung cấp duy nhất.",
        "Giải pháp GoPaperless",
        "Lưu trữ tập trung nhưng không làm doanh nghiệp phụ thuộc vào một nơi duy nhất",
        "Tìm kiếm và lọc hợp đồng theo người lao động, loại tài liệu, trạng thái, thời gian và đơn vị.",
        "Thiết lập thời hạn lưu trữ theo chính sách doanh nghiệp và gói dịch vụ, đồng thời cho phép tải xuống hồ sơ.",
        "Khuyến nghị duy trì phương án sao lưu và xuất dữ liệu định kỳ ngoài việc dữ liệu được lưu trên Nền tảng quốc gia theo thời hạn luật định."
      ],
      "en": [
        "Short answer",
        "The retention period is ",
        "10 years from the date the employment contract terminates",
        ".",
        "Clause 3 Article 18 of Circular No. 08/2026/TT-BNV provides:",
        "“Ten years from the date the employment contract terminates.”",
        "Source: Circular No. 08/2026/TT-BNV",
        "Where the parties enter into several consecutive contracts, the 10-year period is calculated from the termination date of the last contract.",
        "What enterprises should note",
        "The enterprise must still:",
        "Retain the records for which it is responsible.",
        "Protect their integrity.",
        "Ensure that they remain retrievable.",
        "Maintain backup and data-export arrangements.",
        "Avoid complete dependence on a single provider.",
        "GoPaperless solution",
        "Centralized storage without making the enterprise dependent on one repository",
        "Search and filter contracts by employee, document type, status, date and organizational unit.",
        "Configure retention periods under the enterprise's policy and service package while allowing records to be downloaded.",
        "Maintain periodic backups and data exports in addition to the statutory retention of data on the national Platform."
      ]
    }
  },
  {
    "category": "provider",
    "number": "14",
    "question": {
      "vi": "Nhà cung cấp eContract ngừng hoạt động thì hợp đồng và dữ liệu có bị mất không?",
      "en": "If an eContract service provider ceases operations, will contracts and data be lost?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<blockquote>6</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">7</a>\n<p>8</p>\n<ul>\n<li>9</li>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n</ul>\n<p>13</p>\n<h3>14</h3>\n<p>15</p>\n<ul>\n<li>16</li>\n<li>17</li>\n<li>18</li>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n</ul>\n<p>22</p>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">23</div>\n<h3>24</h3>\n<ul>\n<li>25</li>\n<li>26</li>\n<li>27</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Pháp luật đã quy định nghĩa vụ chuyển giao dữ liệu khi nhà cung cấp chấm dứt hoạt động.",
        "Khoản 9 Điều 21 Nghị định 337 quy định:",
        "“Toàn bộ dữ liệu hợp đồng lao động điện tử phải được chuyển giao cho Nền tảng...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Điều 15 Thông tư 08 còn yêu cầu:",
        "“Ưu tiên bảo vệ quyền tra cứu, tải xuống, chứng minh và tiếp cận dữ liệu hợp pháp...”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Thông tư cũng yêu cầu nhà cung cấp hỗ trợ:",
        "Chuyển giao dữ liệu.",
        "Xuất hồ sơ.",
        "Xuất gói dữ liệu chuyển giao.",
        "Không làm mất khả năng chứng minh quyền và nghĩa vụ của người dùng.",
        "Việc nhà cung cấp bị tạm dừng hoặc chấm dứt kết nối không tự động làm mất hiệu lực pháp lý của hợp đồng đã được giao kết hợp lệ, trừ trường hợp có gian lận, giả mạo, vô hiệu hoặc kết luận khác của cơ quan có thẩm quyền.",
        "Doanh nghiệp cần lưu ý",
        "Khi lựa chọn nhà cung cấp, doanh nghiệp phải hỏi trước:",
        "Có xuất được toàn bộ file gốc không?",
        "Có xuất được chữ ký, dấu thời gian và nhật ký giao dịch không?",
        "Định dạng xuất có thể kiểm tra độc lập không?",
        "Quy trình chuyển giao khi chấm dứt dịch vụ thế nào?",
        "Chi phí chuyển giao do ai chịu?",
        "Có cam kết thời gian bàn giao không?",
        "Đây là tiêu chí quan trọng hơn nhiều so với việc giao diện ký đẹp hay không.",
        "Giải pháp GoPaperless",
        "Thiết kế khả năng tải xuống và chuyển giao ngay từ đầu",
        "GoPaperless hỗ trợ tải xuống tài liệu và thao tác theo lô; phạm vi gói dữ liệu bàn giao được xác định trong phương án triển khai.",
        "Doanh nghiệp nên yêu cầu bao gồm file hợp đồng, thông tin chữ ký, dấu thời gian, nhật ký, ID và siêu dữ liệu liên quan.",
        "Điều khoản kết thúc dịch vụ cần quy định định dạng, thời hạn, trách nhiệm và chi phí chuyển giao dữ liệu."
      ],
      "en": [
        "Short answer",
        "The law imposes data-transfer obligations when a provider ceases operations.",
        "Clause 9 Article 21 of Decree No. 337 provides:",
        "“All electronic employment contract data must be transferred to the Platform...”",
        "Source: Decree No. 337/2025/ND-CP",
        "Article 15 of Circular No. 08 also requires:",
        "“Priority shall be given to protecting the lawful rights to search, download, prove and access data...”",
        "Source: Circular No. 08/2026/TT-BNV",
        "The Circular further requires the provider to support:",
        "Data transfer.",
        "Record export.",
        "Export of a data-transfer package.",
        "Preservation of users' ability to prove their rights and obligations.",
        "Suspension or termination of a provider's connection does not automatically invalidate contracts that were lawfully concluded, unless fraud, impersonation, invalidity or another finding is established by a competent authority.",
        "What enterprises should note",
        "Before selecting a provider, the enterprise should ask:",
        "Can all original files be exported?",
        "Can digital signatures, timestamps and transaction logs be exported?",
        "Can the export format be independently verified?",
        "What is the transfer process when the service ends?",
        "Who bears the transfer cost?",
        "Is there a committed handover timeline?",
        "These criteria are far more important than whether the signing interface looks attractive.",
        "GoPaperless solution",
        "Build download and transfer capability into the solution from the outset",
        "GoPaperless supports document downloads and batch operations; the scope of the handover data package is defined in the implementation plan.",
        "The enterprise should require the package to include contract files, signature information, timestamps, logs, IDs and relevant metadata.",
        "Service-termination clauses should specify data formats, deadlines, responsibilities and transfer costs."
      ]
    }
  },
  {
    "category": "provider",
    "number": "15",
    "question": {
      "vi": "Bộ Nội vụ, cơ quan nhà nước hoặc nhân viên trong doanh nghiệp có được xem toàn bộ mức lương không?",
      "en": "May the Ministry of Home Affairs, state authorities or enterprise employees view all salary information?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1<strong>2</strong>3</p>\n<p>4</p>\n<blockquote>5</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">6</a>\n<p>7</p>\n<blockquote>8</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">9</a>\n<p>10</p>\n<blockquote>11</blockquote>\n<h3>12</h3>\n<p>13</p>\n<ul>\n<li><strong>14</strong></li>\n<li><strong>15</strong></li>\n<li><strong>16</strong></li>\n<li><strong>17</strong></li>\n<li><strong>18</strong></li>\n</ul>\n<p>19</p>\n\n\n\n<p>20</p>\n<blockquote>21</blockquote>\n<a class=\"source\" href=\"https://congbao.chinhphu.vn/van-ban/luat-so-91-2025-qh15-45578.htm\" rel=\"noopener\" target=\"_blank\">22</a>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">23</div>\n<h3>24</h3>\n<ul>\n<li>25</li>\n<li>26</li>\n<li>27</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Dữ liệu tiền lương thuộc danh mục dữ liệu của hợp đồng được quản lý trên Nền tảng, nhưng điều đó ",
        "không đồng nghĩa mọi tổ chức, cá nhân đều được quyền truy cập không giới hạn",
        ".",
        "Phụ lục II Thông tư 08 liệt kê các trường dữ liệu:",
        "“Mức lương; Phụ cấp lương; Các khoản bổ sung...”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Khoản 3 Điều 17 Nghị định 337 quy định tổ chức, cá nhân được sử dụng dữ liệu của mình và dữ liệu của người khác:",
        "“Nếu được người đó đồng ý theo quy định của pháp luật.”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Khoản 4 Điều 18 Thông tư 08 yêu cầu dữ liệu phải được xử lý:",
        "“Đúng mục đích, tối thiểu cần thiết, đúng thẩm quyền, đúng phạm vi...”",
        "Doanh nghiệp cần lưu ý",
        "Cần phân biệt:",
        "Dữ liệu được hệ thống quản lý.",
        "Người có quyền truy cập dữ liệu.",
        "Mục đích được phép sử dụng.",
        "Phạm vi dữ liệu được phép xem.",
        "Khả năng ghi nhận nhật ký truy cập.",
        "Cơ quan nhà nước khai thác dữ liệu theo chức năng, nhiệm vụ và quyền hạn được giao; nhân viên doanh nghiệp chỉ nên được xem dữ liệu theo phân quyền công việc. Mọi hoạt động truy cập phải có khả năng ghi nhận và truy vết.",
        "Khoản 2 Điều 3 Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15 quy định:",
        "“Chỉ được thu thập, xử lý dữ liệu cá nhân đúng phạm vi, mục đích cụ thể, rõ ràng, bảo đảm tuân thủ quy định của pháp luật.”",
        "Nguồn: Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15",
        "Giải pháp GoPaperless",
        "Phân quyền theo vai trò và ghi nhận lịch sử truy cập",
        "Thiết lập vai trò người dùng, nhóm làm việc, luồng phê duyệt và quyền xem theo phạm vi công việc.",
        "Giới hạn người quản lý chỉ xem những trường dữ liệu và hồ sơ thực sự cần thiết.",
        "Hỗ trợ báo cáo và nhật ký phục vụ rà soát truy cập bất thường, kiểm toán và yêu cầu bảo vệ dữ liệu cá nhân."
      ],
      "en": [
        "Short answer",
        "Salary data is part of the contract data managed on the Platform, but this does ",
        "not",
        " mean that every organization or individual has unrestricted access.",
        "Appendix II to Circular No. 08 lists the following data fields:",
        "“Salary; salary allowances; additional payments...”",
        "Source: Circular No. 08/2026/TT-BNV",
        "Clause 3 Article 17 of Decree No. 337 provides that organizations and individuals may use their own data and another person's data:",
        "“If that person has given consent in accordance with law.”",
        "Source: Decree No. 337/2025/ND-CP",
        "Clause 4 Article 18 of Circular No. 08 requires data to be processed:",
        "“For the proper purpose, to the minimum extent necessary, by the proper authority and within the proper scope...”",
        "What enterprises should note",
        "The following must be distinguished:",
        "Data managed by the system.",
        "Persons authorized to access the data.",
        "Permitted purposes of use.",
        "The scope of data each person may view.",
        "The ability to log and trace access.",
        "State authorities access data according to their assigned functions, duties and powers. Enterprise personnel should only view data within their job-based authorization. Every access activity should be capable of being logged and traced.",
        "Clause 2 Article 3 of Personal Data Protection Law No. 91/2025/QH15 provides:",
        "“Personal data may only be collected and processed within a specific and clearly defined scope and purpose, in compliance with law.”",
        "Source: Personal Data Protection Law No. 91/2025/QH15",
        "GoPaperless solution",
        "Role-based access control and access-history logging",
        "Configure user roles, workgroups, approval workflows and view permissions according to job scope.",
        "Limit managers to the data fields and records genuinely necessary for their work.",
        "Support reports and logs for reviewing unusual access, conducting audits and responding to personal-data protection requirements."
      ]
    }
  },
  {
    "category": "provider",
    "number": "16",
    "question": {
      "vi": "Làm sao biết nhà cung cấp eContract đã đủ điều kiện kết nối?",
      "en": "How can an enterprise determine whether an eContract service provider is eligible to connect to the Platform?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<blockquote>6</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2026/5/08-bnv.pdf\" rel=\"noopener\" target=\"_blank\">7</a>\n<p>8</p>\n<h3>9</h3>\n<p>10</p>\n<ol>\n<li>11</li>\n<li>12</li>\n<li>13</li>\n<li>14</li>\n<li>15</li>\n<li>16</li>\n<li>17</li>\n<li>18</li>\n</ol>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">19</div>\n<h3>20</h3>\n<ul>\n<li>21</li>\n<li>22</li>\n<li>23</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Doanh nghiệp nên đối chiếu thông tin giới thiệu với danh sách chính thức, hồ sơ pháp lý và tài liệu kỹ thuật tại thời điểm lựa chọn nhà cung cấp.",
        "Khoản 6 Điều 22 Nghị định 337 giao Bộ Nội vụ:",
        "“Công bố danh sách Nhà cung cấp eContract đủ điều kiện kết nối...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Điều 21 Thông tư 08 quy định danh sách phải thể hiện nhà cung cấp:",
        "“Đang kết nối, đang tạm dừng, đã chấm dứt kết nối...”",
        "Nguồn: Thông tư 08/2026/TT-BNV",
        "Danh sách được công bố trên trang giới thiệu của Nền tảng và được cập nhật trong vòng 24 giờ kể từ khi có thay đổi trạng thái kết nối.",
        "Doanh nghiệp cần lưu ý",
        "Trước khi ký hợp đồng dịch vụ, doanh nghiệp cần kiểm tra:",
        "Tên pháp nhân cung cấp dịch vụ.",
        "Tình trạng kết nối trên danh sách chính thức.",
        "Giấy phép liên quan.",
        "Cơ chế ký số, dấu thời gian và chứng thực.",
        "Khả năng chuyển giao dữ liệu.",
        "Điều khoản xử lý khi nhà cung cấp bị tạm dừng kết nối.",
        "Trách nhiệm khi hợp đồng không được cấp ID.",
        "Chính sách thông báo phí và chi phí bên thứ ba.",
        "Khi đánh giá GoPaperless",
        "Khách hàng được đối chiếu cả hồ sơ pháp lý và hồ sơ kỹ thuật",
        "Đối chiếu pháp nhân cung cấp dịch vụ, giấy phép liên quan và tình trạng kết nối chính thức tại thời điểm triển khai.",
        "Rà soát cơ chế ký số, dấu thời gian, chứng thực, an toàn thông tin và chuyển giao dữ liệu.",
        "Xác định rõ trách nhiệm của từng bên nếu kết nối bị tạm dừng, dữ liệu bị trả lỗi hoặc ID chưa được cấp."
      ],
      "en": [
        "Short answer",
        "The enterprise should compare marketing claims with the official list, legal documentation and technical documentation available when selecting the provider.",
        "Clause 6 Article 22 of Decree No. 337 assigns the Ministry of Home Affairs responsibility to:",
        "“Publish the list of eContract service providers eligible to connect...”",
        "Source: Decree No. 337/2025/ND-CP",
        "Article 21 of Circular No. 08 requires the list to show whether a provider is:",
        "“Connected, temporarily suspended or disconnected...”",
        "Source: Circular No. 08/2026/TT-BNV",
        "The list is published on the Platform's information page and updated within 24 hours after a change in connection status.",
        "What enterprises should note",
        "Before signing a service contract, the enterprise should verify:",
        "The legal entity providing the service.",
        "Its connection status on the official list.",
        "Relevant licenses.",
        "The mechanisms for digital signatures, timestamps and authentication.",
        "Data-transfer capability.",
        "Procedures if the provider's connection is suspended.",
        "Responsibility if a contract is not assigned an ID.",
        "Policies for communicating fees and third-party charges.",
        "When evaluating GoPaperless",
        "Verify both the legal dossier and the technical dossier",
        "Verify the service-provider legal entity, relevant licenses and official connection status at the time of implementation.",
        "Review digital-signature, timestamp, authentication, information-security and data-transfer mechanisms.",
        "Clearly define each party's responsibilities if the connection is suspended, data is returned with errors or an ID has not been issued."
      ]
    }
  },
  {
    "category": "provider",
    "number": "17",
    "question": {
      "vi": "Nhà cung cấp eContract có cần giấy phép chuyên ngành không?",
      "en": "Does an eContract service provider require a specialized license?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong></p>\n<p>2</p>\n<blockquote>3</blockquote>\n<a class=\"source\" href=\"https://datafiles.chinhphu.vn/cpp/files/vbpq/2025/12/337-cp.signed.pdf\" rel=\"noopener\" target=\"_blank\">4</a>\n<p>5</p>\n<p>6</p>\n<ul>\n<li>7</li>\n<li>8</li>\n<li>9</li>\n<li>10</li>\n<li>11</li>\n<li>12</li>\n<li>13</li>\n<li>14</li>\n</ul>\n<h3>15</h3>\n<p>16</p>\n<ul>\n<li>17</li>\n<li>18</li>\n<li>19</li>\n<li>20</li>\n<li>21</li>\n</ul>\n<p>22</p>\n\n<div class=\"solution-box\">\n<div class=\"solution-kicker\">23</div>\n<h3>24</h3>\n<ul>\n<li>25</li>\n<li>26</li>\n<li>27</li>\n</ul>\n</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có những điều kiện không thể chỉ đáp ứng bằng việc phát triển một phần mềm ký tài liệu.",
        "Điểm c khoản 3 Điều 6 Nghị định 337 yêu cầu nhà cung cấp phải có:",
        "“Giấy phép kinh doanh dịch vụ tin cậy...”",
        "Nguồn: Nghị định 337/2025/NĐ-CP",
        "Loại dịch vụ được phép kinh doanh phải bao gồm cung cấp dịch vụ chứng thực thông điệp dữ liệu theo pháp luật về giao dịch điện tử.",
        "Ngoài ra, nhà cung cấp còn phải đáp ứng các nhóm điều kiện về:",
        "Phần mềm ký số và kiểm tra chữ ký số.",
        "Xác thực đúng chủ thể.",
        "Công nghệ đối chiếu dữ liệu và sinh trắc học.",
        "Bảo mật, an toàn thông tin.",
        "Lưu trữ và duy trì tính toàn vẹn.",
        "Kết nối API với Nền tảng.",
        "Phương án dự phòng và khắc phục sự cố.",
        "Chuyển đổi giữa hợp đồng giấy và điện tử.",
        "Doanh nghiệp cần lưu ý",
        "Một phần mềm có chức năng:",
        "Tải PDF.",
        "Vẽ chữ ký.",
        "Gửi OTP.",
        "Gửi email.",
        "Theo dõi trạng thái.",
        "chưa đủ để kết luận đó là một nhà cung cấp eContract đáp ứng Nghị định 337.",
        "Giải pháp GoPaperless",
        "Kết hợp nền tảng quy trình với hệ sinh thái định danh và chữ ký số",
        "Hỗ trợ nhiều phương thức định danh và chữ ký số, bao gồm mô hình ký từ xa và tích hợp VNeID theo phạm vi giải pháp.",
        "Có các lựa chọn Portal, API/Universal và Agent để triển khai độc lập hoặc gắn vào hệ thống doanh nghiệp.",
        "Hồ sơ triển khai phải xác định rõ đơn vị cung cấp từng dịch vụ tin cậy, giấy phép, SLA và trách nhiệm vận hành."
      ],
      "en": [
        "Short answer",
        "Certain conditions cannot be satisfied merely by developing document-signing software.",
        "Point c Clause 3 Article 6 of Decree No. 337 requires the provider to hold:",
        "“A license to provide trust services...”",
        "Source: Decree No. 337/2025/ND-CP",
        "The licensed scope must include the provision of data-message authentication services under the law on electronic transactions.",
        "In addition, the provider must meet requirements concerning:",
        "Digital-signing and digital-signature verification software.",
        "Accurate authentication of the parties.",
        "Data-matching and biometric technologies.",
        "Security and information safety.",
        "Retention and preservation of integrity.",
        "API connectivity with the Platform.",
        "Business-continuity and incident-recovery plans.",
        "Conversion between paper and electronic contracts.",
        "What enterprises should note",
        "Software that can:",
        "Upload a PDF.",
        "Draw a signature.",
        "Send an OTP.",
        "Send an email.",
        "Track a status.",
        "is not, for those reasons alone, an eContract service provider that satisfies Decree No. 337.",
        "GoPaperless solution",
        "Combine a workflow platform with an identification and digital-signature ecosystem",
        "Support multiple identification and digital-signature methods, including remote signing and VNeID integration within the solution scope.",
        "Offer Portal, API/Universal and Agent options for standalone deployment or integration into enterprise systems.",
        "The implementation dossier should clearly identify the provider of each trust service, its license, the SLA and operational responsibilities."
      ]
    }
  },
  {
    "category": "solution",
    "number": "18",
    "question": {
      "vi": "Doanh nghiệp đã có HRM hoặc ERP, có phải thay hệ thống mới để dùng GoPaperless không?",
      "en": "If an enterprise already has an HRM or ERP system, must it replace that system to use GoPaperless?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n</ul>\n<div class=\"key-point\"><strong>7</strong>8</div>\n<a class=\"source\" href=\"https://gopaperless.mobile-id.vn/solutions/e-identification-api\" target=\"_blank\" rel=\"noopener\">9</a>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không nhất thiết.",
        " GoPaperless có thể được sử dụng như một cổng quản trị độc lập hoặc tích hợp vào hệ thống sẵn có thông qua Portal API, Universal API và các thành phần kết nối.",
        "GoPaperless xử lý như thế nào?",
        "Nhận dữ liệu nhân sự từ HRM, ERP, ATS hoặc file dữ liệu theo cấu trúc đã thống nhất.",
        "Tạo tài liệu từ mẫu, chuyển qua luồng phê duyệt và gửi ký mà không bắt HR nhập lại toàn bộ thông tin.",
        "Đồng bộ trạng thái ký, kết quả và dữ liệu cần thiết về hệ thống nguồn theo phương án API hoặc webhook được thiết kế.",
        "Điểm cần xác nhận:",
        " khả năng tích hợp phụ thuộc vào API, chất lượng dữ liệu và quyền truy cập của hệ thống hiện tại. Một buổi kiểm tra kỹ thuật ngắn có thể xác định ngay mô hình phù hợp.",
        "Tham khảo: Các mô hình tích hợp GoPaperless"
      ],
      "en": [
        "Short answer",
        "Not necessarily.",
        " GoPaperless may operate as an independent management portal or integrate with an existing system through Portal API, Universal API and other connectivity components.",
        "How GoPaperless handles this",
        "Receive employee data from an HRM, ERP, ATS or a data file in an agreed structure.",
        "Generate documents from templates, route them through approval and send them for signing without requiring HR to re-enter all information.",
        "Synchronize signing statuses, results and necessary data back to the source system through a designed API or webhook arrangement.",
        "Point to confirm:",
        " integration capability depends on the current system's APIs, data quality and access permissions. A short technical assessment can quickly identify the appropriate model.",
        "View details: GoPaperless integration models"
      ]
    }
  },
  {
    "category": "solution",
    "number": "19",
    "question": {
      "vi": "GoPaperless có thể tạo và phát hành từ vài chục đến hàng nghìn hợp đồng theo lô không?",
      "en": "Can GoPaperless generate and issue batches ranging from dozens to thousands of contracts?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ol>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n  <li>8</li>\n</ol>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">9</div><p>10</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có thể tổ chức quy trình hàng loạt.",
        " Số lượng cụ thể trong mỗi đợt cần được kiểm thử theo mẫu hợp đồng, dữ liệu, hạ tầng và tiêu chí vận hành của doanh nghiệp.",
        "Quy trình điển hình",
        "Nhận dữ liệu từ HRM hoặc file chuẩn.",
        "Kiểm tra trường bắt buộc, dữ liệu trùng và sai định dạng.",
        "Trộn dữ liệu vào mẫu hợp đồng.",
        "Trình duyệt và phát hành theo lô.",
        "Xuất báo cáo hồ sơ thành công, hồ sơ lỗi và nguyên nhân.",
        "Cách kiểm chứng thực tế",
        "Doanh nghiệp có thể dùng một bộ dữ liệu mẫu và một mẫu hợp đồng thật để thực hiện thử nghiệm trước khi phê duyệt triển khai diện rộng."
      ],
      "en": [
        "Short answer",
        "A bulk process can be organized.",
        " The specific number in each batch should be tested against the enterprise's contract template, data, infrastructure and operational criteria.",
        "Typical process",
        "Receive data from the HRM or a standardized file.",
        "Validate mandatory fields, duplicates and formatting errors.",
        "Merge data into the contract template.",
        "Route for approval and issue the batch.",
        "Produce reports of successful records, failed records and error reasons.",
        "How to verify this in practice",
        "The enterprise can use a sample dataset and an actual contract template for a pilot before approving a large-scale rollout."
      ]
    },
    "resources": [
      {
        "type": "video",
        "href": "https://youtu.be/bUF5daPItpQ",
        "title": {
          "vi": "Video hướng dẫn",
          "en": "Instructional video"
        },
        "description": {
          "vi": "Video hướng dẫn chi tiết quy trình và cách sử dụng.",
          "en": "A detailed video walkthrough of the process and how to use it."
        }
      },
      {
        "type": "file",
        "href": "https://drive.google.com/file/d/1grw04zEeNwqSPyo8NgiQ1IEov0Qrx0Bv/view?usp=drive_link",
        "title": {
          "vi": "Tài liệu hướng dẫn (PDF)",
          "en": "Instruction guide (PDF)"
        },
        "description": {
          "vi": "File hướng dẫn triển khai và thao tác.",
          "en": "Guide to batch deployment and operations."
        }
      }
    ]
  },
  {
    "category": "solution",
    "number": "20",
    "question": {
      "vi": "Lãnh đạo có thể ký trên điện thoại mà không phải mang laptop và USB Token không?",
      "en": "Can an executive sign on a mobile phone without carrying a laptop and USB Token?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n</ul>\n<div class=\"key-point\"><strong>7</strong>8</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có",
        ", khi doanh nghiệp sử dụng chữ ký số từ xa hoặc phương thức ký di động phù hợp và người ký có chứng thư số hợp lệ.",
        "GoPaperless xử lý như thế nào?",
        "GoPaperless Portal và ứng dụng di động hỗ trợ xử lý tài liệu ở bất cứ đâu.",
        "GoPaperless Agent hỗ trợ tích hợp VNeID và các nhà cung cấp chữ ký số từ xa được cấp phép.",
        "Người ký có thể xem tài liệu, xác thực và ký mà không cần cắm USB Token vào máy tính trong mô hình ký từ xa.",
        "Điều kiện:",
        " thẩm quyền ký, chứng thư số, phương thức xác thực và chính sách ký của doanh nghiệp vẫn phải được cấu hình đúng."
      ],
      "en": [
        "Short answer",
        "Yes",
        ", where the enterprise uses a suitable remote or mobile digital-signing method and the signer holds a valid digital certificate.",
        "How GoPaperless handles this",
        "GoPaperless Portal and the mobile application support document processing from any location.",
        "GoPaperless Agent supports integration with VNeID and licensed remote digital-signature providers.",
        "Under a remote-signing model, the signer can review, authenticate and sign the document without connecting a USB Token to a computer.",
        "Conditions:",
        " signing authority, the digital certificate, authentication method and the enterprise's signing policy must still be configured correctly."
      ]
    },
    "resources": [
      {
        "type": "video",
        "href": "https://youtu.be/JpcQ4uZU1gU",
        "title": {
          "vi": "Video hướng dẫn",
          "en": "Instructional video"
        },
        "description": {
          "vi": "Video hướng dẫn ký trên thiết bị di động.",
          "en": "Video guide to signing on a mobile device."
        }
      },
      {
        "type": "file",
        "href": "https://drive.google.com/file/d/1WCvn-VVwBeWhm2RlWWsok7th3li2n467/view?usp=drive_link",
        "title": {
          "vi": "Tài liệu hướng dẫn (PDF)",
          "en": "Instruction guide (PDF)"
        },
        "description": {
          "vi": "File hướng dẫn cấu hình và sử dụng chữ ký số từ xa.",
          "en": "Guide to configuring and using remote digital signatures."
        }
      }
    ]
  },
  {
    "category": "solution",
    "number": "21",
    "question": {
      "vi": "Người lao động có phải cài thêm ứng dụng hoặc tạo tài khoản GoPaperless mới ký được không?",
      "en": "Must an employee install another application or create a GoPaperless account before signing?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">7</div><p>8</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không phải trong mọi trường hợp.",
        " GoPaperless hỗ trợ mô hình mời ký không cần tài khoản; người lao động nhận liên kết, xem tài liệu và thực hiện quy trình xác thực, ký theo cấu hình.",
        "Điều cần phân biệt",
        "Người lao động có thể không cần tạo tài khoản GoPaperless.",
        "Nếu quy trình sử dụng VNeID, người lao động vẫn cần tài khoản và ứng dụng VNeID đáp ứng điều kiện sử dụng.",
        "Nếu sử dụng một nhà cung cấp chữ ký số khác, người lao động phải đáp ứng điều kiện của dịch vụ chữ ký số đó.",
        "Giá trị vận hành",
        "Giảm đáng kể số bước đăng ký mới, số cuộc gọi hướng dẫn và tình trạng người lao động bỏ dở vì không nhớ tài khoản hoặc mật khẩu."
      ],
      "en": [
        "Short answer",
        "Not in every case.",
        " GoPaperless supports accountless invitations: the employee receives a link, reviews the document and completes the configured authentication and signing process.",
        "Important distinctions",
        "The employee may not need to create a GoPaperless account.",
        "If the process uses VNeID, the employee must still have a qualifying VNeID account and application.",
        "If another digital-signature provider is used, the employee must meet that service's conditions.",
        "Operational value",
        "Significantly reduce new-registration steps, support calls and abandoned signing processes caused by forgotten accounts or passwords."
      ]
    },
    "resources": [
      {
        "type": "video",
        "href": "https://youtu.be/kFNmUeQWqRk",
        "title": {
          "vi": "Video hướng dẫn",
          "en": "Instructional video"
        },
        "description": {
          "vi": "Video hướng dẫn quy trình mời ký không cần tài khoản.",
          "en": "Video guide to accountless signing invitations."
        }
      },
      {
        "type": "file",
        "href": "https://drive.google.com/file/d/1PAbEtgPym5KNVH4TABaONCAP-YaxckTQ/view?usp=drive_link",
        "title": {
          "vi": "Tài liệu hướng dẫn (PDF)",
          "en": "Instruction guide (PDF)"
        },
        "description": {
          "vi": "File hướng dẫn trải nghiệm ký dành cho người lao động.",
          "en": "Guide to the employee signing experience."
        }
      }
    ]
  },
  {
    "category": "solution",
    "number": "22",
    "question": {
      "vi": "HR có theo dõi được ai đã ký, ai chưa ký và tự động nhắc hay không?",
      "en": "Can HR track who has signed, who has not signed and send automatic reminders?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"key-point\">8</div>\n<a class=\"source\" href=\"https://gopaperless.mobile-id.vn/pricing/portal\" target=\"_blank\" rel=\"noopener\">9</a>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có.",
        " GoPaperless hỗ trợ quản lý người tham gia, thời hạn, nhắc việc, quy trình và báo cáo trạng thái.",
        "Thông tin HR có thể theo dõi",
        "Hồ sơ đã gửi, đã xem, đang chờ ký, hoàn tất hoặc thất bại.",
        "Người đang giữ bước xử lý và thời hạn của từng bước.",
        "Danh sách cần nhắc, hồ sơ quá hạn và nguyên nhân lỗi.",
        "Tỷ lệ hoàn tất theo đơn vị, đợt tuyển dụng hoặc loại hợp đồng.",
        "Nhờ đó, HR không phải liên tục nhắn tin hỏi từng lãnh đạo hoặc từng người lao động để biết hồ sơ đang ở đâu.",
        "Tham khảo: Deadlines, reminders, workflows và reporting"
      ],
      "en": [
        "Short answer",
        "Yes.",
        " GoPaperless supports participant management, deadlines, reminders, workflows and status reporting.",
        "Information HR can track",
        "Records sent, viewed, awaiting signature, completed or failed.",
        "The person currently responsible for each step and the deadline for that step.",
        "Reminder lists, overdue records and error reasons.",
        "Completion rates by unit, recruitment campaign or contract type.",
        "As a result, HR does not need to repeatedly message each executive or employee to determine where a record is in the process.",
        "View details: Deadlines, reminders, workflows and reporting"
      ]
    }
  },
  {
    "category": "solution",
    "number": "23",
    "question": {
      "vi": "Khi hợp đồng chưa được cấp ID hoặc bị trả lỗi, HR có phải theo dõi thủ công không?",
      "en": "When a contract has not received an ID or is returned with an error, must HR track it manually?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">8</div><p>9</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không nên phải theo dõi bằng bảng Excel hoặc email rời rạc.",
        " Trong phạm vi kết nối HĐLĐ điện tử được kích hoạt, GoPaperless có thể tổ chức việc theo dõi trạng thái và xử lý lỗi tập trung.",
        "Các trạng thái cần được quản lý",
        "Đã ký đủ bên nhưng chưa gửi.",
        "Đã gửi và đang chờ Nền tảng tiếp nhận.",
        "Đang kiểm tra, đã cấp ID hoặc bị từ chối.",
        "Đang chờ bổ sung dữ liệu, gửi lại hoặc cần xử lý thủ công.",
        "GoPaperless",
        "Ghi nhận mốc thời gian, phản hồi lỗi, số lần gửi và người chịu trách nhiệm xử lý, giúp doanh nghiệp kiểm soát hai mốc 24 giờ thay vì chờ đến khi phát sinh khiếu nại."
      ],
      "en": [
        "Short answer",
        "HR should not need to track this through spreadsheets or fragmented emails.",
        " Within the activated electronic employment contract connection scope, GoPaperless can centralize status monitoring and error handling.",
        "Statuses that should be managed",
        "Signed by all parties but not yet submitted.",
        "Submitted and awaiting Platform receipt.",
        "Under review, assigned an ID or rejected.",
        "Awaiting additional data, resubmission or manual handling.",
        "GoPaperless",
        "Record timestamps, error responses, submission attempts and the responsible handler so the enterprise can control both 24-hour time limits instead of discovering a problem only after a complaint arises."
      ]
    }
  },
  {
    "category": "solution",
    "number": "24",
    "question": {
      "vi": "GoPaperless cung cấp những bằng chứng gì khi có thanh tra hoặc tranh chấp?",
      "en": "What evidence does GoPaperless provide in the event of an inspection or dispute?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<ul>\n  <li>2</li>\n  <li>3</li>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">7</div><p>8</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Hồ sơ cần nhiều hơn một bản PDF. Tùy cấu hình dịch vụ, bộ hồ sơ có thể bao gồm:",
        "Bản tài liệu hoàn tất và phiên bản đã được các bên ký.",
        "Thông tin chữ ký, chứng thư số, chủ thể và thời điểm ký.",
        "Dấu thời gian và kết quả chứng thực thông điệp dữ liệu.",
        "Nhật ký mời ký, xem, xác thực, ký, gửi, tải xuống và xử lý lỗi.",
        "ID hợp đồng và các tài liệu vòng đời liên quan.",
        "Giá trị của GoPaperless",
        "Tập trung các bằng chứng vào cùng một hồ sơ để doanh nghiệp có thể tra cứu và xuất trình nhanh, thay vì ghép lại từ email, tin nhắn, file PDF và dữ liệu của nhiều hệ thống."
      ],
      "en": [
        "Short answer",
        "The record should contain more than a PDF. Depending on the service configuration, the evidence package may include:",
        "The completed document and the version signed by the parties.",
        "Signature, digital-certificate, party and signing-time information.",
        "Timestamps and data-message authentication results.",
        "Logs of invitations, viewing, authentication, signing, submission, downloading and error handling.",
        "The contract ID and related lifecycle documents.",
        "The value of GoPaperless",
        "Consolidate evidence into a single record so the enterprise can retrieve and produce it quickly, rather than reconstructing it from emails, messages, PDFs and data held across multiple systems."
      ]
    }
  },
  {
    "category": "solution",
    "number": "25",
    "question": {
      "vi": "Hợp đồng, phụ lục, tạm hoãn và chấm dứt có được quản lý thành một vòng đời thống nhất không?",
      "en": "Can contracts, appendices, suspensions and terminations be managed as one unified lifecycle?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"key-point\">8</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có thể.",
        " Đây là khác biệt quan trọng giữa quản trị hợp đồng và chỉ gửi một file đi ký.",
        "GoPaperless hỗ trợ",
        "Liên kết hợp đồng gốc với phụ lục, thỏa thuận tạm hoãn, gia hạn và chấm dứt.",
        "Quản lý trạng thái, người ký, ngày hiệu lực và lịch sử của từng tài liệu.",
        "Tra cứu toàn bộ hồ sơ theo một người lao động hoặc một ID hợp đồng.",
        "Cảnh báo các mốc hết hạn, gia hạn hoặc cần cập nhật.",
        "Doanh nghiệp nhìn thấy “một vòng đời hồ sơ” thay vì nhiều file nằm rải rác ở email, thư mục cá nhân và phần mềm khác nhau."
      ],
      "en": [
        "Short answerYes. This is an important distinction between contract management and merely sending a file for signature.",
        "GoPaperless supports",
        "Linking the original contract to appendices, suspension agreements, extensions and termination documents.",
        "Managing the status, signers, effective date and history of each document.",
        "Searching the complete record by employee or contract ID.",
        "Alerting users to expiry, renewal and update milestones.",
        "The enterprise sees ",
        "one record lifecycle",
        " rather than multiple files scattered across email, personal folders and separate software systems."
      ]
    }
  },
  {
    "category": "solution",
    "number": "26",
    "question": {
      "vi": "Dữ liệu lương, CCCD và thông tin cá nhân có thể được giới hạn quyền xem theo vai trò không?",
      "en": "Can access to salary data, citizen ID information and personal data be restricted by role?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<p>3</p>\n<blockquote>4</blockquote>\n<a class=\"source\" href=\"https://congbao.chinhphu.vn/van-ban/luat-so-91-2025-qh15-45578.htm\" target=\"_blank\" rel=\"noopener\">5</a>\n<h3>6</h3>\n<ul>\n  <li>7</li>\n  <li>8</li>\n  <li>9</li>\n</ul>\n<div class=\"key-point\">10</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có.",
        " Phân quyền theo vai trò là yêu cầu vận hành thiết yếu đối với hồ sơ lao động.",
        "Khoản 2 Điều 3 Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15 quy định:",
        "“Chỉ được thu thập, xử lý dữ liệu cá nhân đúng phạm vi, mục đích cụ thể, rõ ràng, bảo đảm tuân thủ quy định của pháp luật.”",
        "Nguồn: Luật Bảo vệ dữ liệu cá nhân số 91/2025/QH15",
        "GoPaperless hỗ trợ",
        "Vai trò, nhóm người dùng, quyền xử lý và luồng phê duyệt.",
        "Giới hạn quyền xem theo đơn vị, loại hồ sơ và nhiệm vụ.",
        "Ghi nhận lịch sử thao tác để phục vụ kiểm tra và điều tra sự cố.",
        "Phân quyền phải được thiết kế từ ma trận trách nhiệm thực tế của doanh nghiệp, không chỉ dựa trên chức danh chung."
      ],
      "en": [
        "Short answer",
        "Yes.",
        " Role-based access control is an essential operational requirement for employment records.",
        "Clause 2 Article 3 of Personal Data Protection Law No. 91/2025/QH15 provides:",
        "“Personal data may only be collected and processed within a specific and clearly defined scope and purpose, in compliance with law.”",
        "Source: Personal Data Protection Law No. 91/2025/QH15",
        "GoPaperless supports",
        "Roles, user groups, processing permissions and approval workflows.",
        "Restrictions on viewing by organizational unit, record type and assigned task.",
        "Operation-history logging for review and incident investigation.",
        "Access control should be designed from the enterprise's actual responsibility matrix, not merely from generic job titles."
      ]
    }
  },
  {
    "category": "solution",
    "number": "27",
    "question": {
      "vi": "Hợp đồng hoàn tất có tự động gửi cho người lao động và đồng bộ về HRM không?",
      "en": "Can a completed contract be sent automatically to the employee and synchronized back to the HRM?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ol>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ol>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">8</div><p>9</p></div>\n<a class=\"source\" href=\"https://gopaperless.mobile-id.vn/solutions/e-identification-api\" target=\"_blank\" rel=\"noopener\">10</a>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có thể cấu hình.",
        " Hợp đồng hoàn tất được gửi cho người lao động qua phương tiện đã thỏa thuận; trạng thái và dữ liệu có thể đồng bộ về hệ thống nguồn khi hai hệ thống được tích hợp.",
        "Luồng triển khai phổ biến",
        "HRM gửi dữ liệu và yêu cầu tạo hợp đồng.",
        "GoPaperless điều phối phê duyệt và ký.",
        "Bản hoàn tất được gửi cho người lao động.",
        "Trạng thái, đường dẫn hồ sơ, ID và dữ liệu cần thiết được trả về HRM.",
        "Lợi ích",
        "HR không phải tải file từ một hệ thống rồi tải lại lên hệ thống khác; hồ sơ nhân sự được cập nhật nhất quán hơn.",
        "Tham khảo: Portal API và Universal API"
      ],
      "en": [
        "Short answer",
        "Yes, this can be configured.",
        " The completed contract is sent to the employee through the agreed means, and status and data can be synchronized back to the source system when the two systems are integrated.",
        "Common implementation flow",
        "The HRM sends data and a contract-generation request.",
        "GoPaperless coordinates approval and signing.",
        "The completed version is sent to the employee.",
        "The status, record link, ID and required data are returned to the HRM.",
        "Benefit",
        "HR does not need to download a file from one system and upload it into another; employee records are updated more consistently.",
        "View details: Portal API and Universal API"
      ]
    }
  },
  {
    "category": "solution",
    "number": "28",
    "question": {
      "vi": "Doanh nghiệp có thể đưa kho hợp đồng giấy và hợp đồng điện tử cũ vào GoPaperless không?",
      "en": "Can an enterprise import its archive of paper contracts and older electronic contracts into GoPaperless?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"key-point\">8</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có thể thực hiện dự án nhập và chuẩn hóa dữ liệu.",
        " Tuy nhiên, chất lượng kết quả phụ thuộc vào chất lượng file, dữ liệu chỉ mục và tình trạng pháp lý của từng hồ sơ.",
        "Các bước nên thực hiện",
        "Kiểm kê và phân loại: giấy, scan, điện tử có chữ ký, điện tử thiếu thành phần.",
        "Chuẩn hóa khóa tra cứu như mã nhân viên, CCCD, loại hợp đồng và ngày hiệu lực.",
        "Nhập theo lô, kiểm tra trùng và lập báo cáo ngoại lệ.",
        "Áp dụng quy trình chuyển đổi hoặc bổ sung thành phần đối với hồ sơ cần thiết.",
        "Việc đưa file vào hệ thống giúp quản lý tập trung; việc hồ sơ có giá trị như bản gốc hay đủ điều kiện cấp ID vẫn phải được đánh giá theo pháp luật."
      ],
      "en": [
        "Short answer",
        "A data-import and standardization project can be carried out.",
        " However, the quality of the result depends on file quality, index data and the legal status of each record.",
        "Recommended steps",
        "Inventory and classify records as paper, scanned, electronically signed or electronic but missing required components.",
        "Standardize search keys such as employee code, citizen ID number, contract type and effective date.",
        "Import records in batches, check for duplicates and produce an exception report.",
        "Apply a conversion process or supplement missing components where necessary.",
        "Importing files into the system enables centralized management. Whether a record has the value of an original or is eligible for ID issuance must still be assessed under applicable law."
      ]
    }
  },
  {
    "category": "solution",
    "number": "29",
    "question": {
      "vi": "Có thể triển khai thử GoPaperless mà không làm xáo trộn toàn bộ doanh nghiệp không?",
      "en": "Can GoPaperless be piloted without disrupting the entire enterprise?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n</ul>\n<h3>7</h3>\n<ul>\n  <li>8</li>\n  <li>9</li>\n  <li>10</li>\n  <li>11</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">12</div><p>13</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Có.",
        " Mô hình thí điểm có kiểm soát thường an toàn hơn triển khai đồng loạt.",
        "Phạm vi thí điểm phù hợp",
        "Một loại hợp đồng và một nhóm nhân sự mới.",
        "Một nhà máy, chi nhánh hoặc phòng ban.",
        "Một luồng ký có số người tham gia rõ ràng.",
        "Chỉ số nên đo",
        "Thời gian từ tạo đến hoàn tất.",
        "Tỷ lệ lỗi dữ liệu và tỷ lệ ký thành công.",
        "Số lượt HR phải hỗ trợ thủ công.",
        "Khả năng đồng bộ, tra cứu và xuất hồ sơ.",
        "GoPaperless",
        "Có thể bắt đầu bằng Portal độc lập, sau đó mới tích hợp API khi quy trình và dữ liệu đã được xác nhận."
      ],
      "en": [
        "Short answer",
        "Yes.",
        " A controlled pilot is generally safer than an enterprise-wide launch.",
        "Suitable pilot scope",
        "One contract type and one group of newly hired employees.",
        "One factory, branch or department.",
        "One signing workflow with clearly identified participants.",
        "Metrics to measure",
        "Time from document creation to completion.",
        "Data-error rate and successful-signing rate.",
        "Number of cases requiring manual HR support.",
        "Ability to synchronize, search and export records.",
        "GoPaperless",
        "The enterprise can begin with the standalone Portal and add API integration after the process and data have been validated."
      ]
    }
  },
  {
    "category": "solution",
    "number": "30",
    "question": {
      "vi": "GoPaperless phù hợp với doanh nghiệp quy mô nào?",
      "en": "What size of enterprise is GoPaperless suitable for?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<div class=\"comparison-grid\">\n  <div><strong>2</strong><span>3</span></div>\n  <div><strong>4</strong><span>5</span></div>\n  <div><strong>6</strong><span>7</span></div>\n</div>\n<div class=\"key-point\">8</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "GoPaperless có thể được cấu hình cho doanh nghiệp nhỏ, đội nhóm chuyên môn và tổ chức có quy mô lớn; mô hình triển khai khác nhau theo sản lượng và mức độ tích hợp.",
        "Doanh nghiệp nhỏ",
        "Portal sẵn dùng, mẫu quy trình đơn giản, ít tích hợp.",
        "Doanh nghiệp vừa",
        "Quy trình nhiều vai trò, tạo theo lô, báo cáo và kết nối HRM.",
        "Doanh nghiệp lớn",
        "API/Universal, phân quyền nhiều đơn vị, SLA, tích hợp và quản trị dữ liệu nâng cao.",
        "Quy mô lao động chỉ là một yếu tố. Sản lượng hợp đồng, số chi nhánh, mức phân tán người ký và yêu cầu tích hợp mới quyết định kiến trúc phù hợp."
      ],
      "en": [
        "Short answer",
        "GoPaperless can be configured for small enterprises, specialist teams and large organizations; the deployment model varies according to transaction volume and the required level of integration.",
        "Small enterprises",
        "Ready-to-use Portal, simple workflow templates and limited integration.",
        "Medium-sized enterprises",
        "Multi-role workflows, batch generation, reporting and HRM connectivity.",
        "Large enterprises",
        "API/Universal, multi-unit authorization, SLAs, integrations and advanced data governance.",
        "Employee headcount is only one factor. Contract volume, number of branches, geographical dispersion of signers and integration requirements determine the appropriate architecture."
      ]
    }
  },
  {
    "category": "solution",
    "number": "31",
    "question": {
      "vi": "Nên chọn GoPaperless Portal, API/Universal hay Agent?",
      "en": "Should an enterprise choose GoPaperless Portal, API/Universal or Agent?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<div class=\"model-table\" role=\"table\" aria-label=\"So sánh mô hình GoPaperless\">\n  <div class=\"model-row header\" role=\"row\"><span>2</span><span>3</span><span>4</span></div>\n  <div class=\"model-row\" role=\"row\"><strong>5</strong><span>6</span><span>7</span></div>\n  <div class=\"model-row\" role=\"row\"><strong>8</strong><span>9</span><span>10</span></div>\n  <div class=\"model-row\" role=\"row\"><strong>11</strong><span>12</span><span>13</span></div>\n</div>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">14</div><p>15</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Mỗi mô hình giải quyết một nhu cầu khác nhau và có thể được kết hợp.",
        "Mô hình",
        "Phù hợp khi",
        "Giá trị chính",
        "Portal",
        "Cần triển khai nhanh, chưa có hệ thống ký tập trung.",
        "Giao diện sẵn dùng, quy trình, nhắc hạn, quản lý và báo cáo.",
        "API / Universal",
        "Muốn giữ trải nghiệm trong HRM, ERP, website hoặc ứng dụng hiện tại.",
        "Nhúng quy trình định danh, mời ký và ký vào hệ thống doanh nghiệp.",
        "Agent",
        "Muốn ký trực tiếp trong Adobe, Microsoft Office hoặc ứng dụng nghiệp vụ.",
        "Ký từ xa, tích hợp VNeID và nhiều nhà cung cấp CA.",
        "Khuyến nghị",
        "Doanh nghiệp nên lựa chọn sau khi xác định điểm phát sinh tài liệu, nơi dữ liệu gốc được quản lý và trải nghiệm mong muốn của người ký."
      ],
      "en": [
        "Short answer",
        "Each model addresses a different need, and the models may be combined.",
        "Model",
        "Suitable when",
        "Main value",
        "Portal",
        "The enterprise needs a fast rollout and does not yet have a centralized signing system.",
        "Ready-to-use interface, workflows, deadline reminders, management and reporting.",
        "API / Universal",
        "The enterprise wants to retain the user experience within its current HRM, ERP, website or application.",
        "Embed identification, signing invitations and signing into the enterprise system.",
        "Agent",
        "Users need to sign directly in Adobe, Microsoft Office or a business application.",
        "Remote signing, VNeID integration and support for multiple certification-authority providers.",
        "Recommendation",
        "Choose the model after identifying where documents originate, where source data is managed and what signing experience users require."
      ]
    },
    "resources": [
      {
        "type": "video",
        "href": "https://youtu.be/jQAgWK-WpiI",
        "title": {
          "vi": "Video hướng dẫn (Agent)",
          "en": "Instructional video (Agent)"
        },
        "description": {
          "vi": "Video hướng dẫn mô hình GoPaperless Agent.",
          "en": "Video guide to the GoPaperless Agent model."
        }
      },
      {
        "type": "video",
        "href": "https://youtu.be/ESTTioFoI7I",
        "title": {
          "vi": "Video hướng dẫn (Portal)",
          "en": "Instructional video (Portal)"
        },
        "description": {
          "vi": "Video hướng dẫn mô hình GoPaperless Portal.",
          "en": "Video guide to the GoPaperless Portal model."
        }
      },
      {
        "type": "file",
        "href": "https://drive.google.com/file/d/10rCYBHoCWUWlb_iuFoMSrxms94noChAN/view?usp=drive_link",
        "title": {
          "vi": "Tài liệu hướng dẫn (PDF)",
          "en": "Instruction guide (PDF)"
        },
        "description": {
          "vi": "File so sánh và hướng dẫn lựa chọn mô hình triển khai.",
          "en": "Comparison guide for choosing a deployment model."
        }
      }
    ]
  },
  {
    "category": "solution",
    "number": "32",
    "question": {
      "vi": "Chi phí triển khai GoPaperless được hình thành từ những thành phần nào?",
      "en": "What components determine the cost of implementing GoPaperless?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<h3>2</h3>\n<ul>\n  <li>3</li>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">8</div><p>9</p></div>\n<a class=\"source\" href=\"https://gopaperless.mobile-id.vn/pricing/portal\" target=\"_blank\" rel=\"noopener\">10</a>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không có một đơn giá duy nhất phù hợp cho mọi doanh nghiệp. Tổng chi phí phụ thuộc vào phạm vi và sản lượng.",
        "Các thành phần cần được tách rõ",
        "Phí nền tảng, tài khoản quản trị hoặc gói doanh nghiệp.",
        "Phí chữ ký số, dấu thời gian và chứng thực thông điệp dữ liệu.",
        "Phí xác thực định danh, VNeID hoặc dịch vụ bên thứ ba nếu phát sinh.",
        "Phí SMS, kênh thông báo, lưu trữ và sản lượng vượt gói.",
        "Phí tích hợp API, chuyển đổi dữ liệu, đào tạo và hỗ trợ theo SLA.",
        "Cách GoPaperless báo giá",
        "Phương án tốt phải tách phí nền tảng và phí bên thứ ba, nêu giả định sản lượng, trường hợp ký lại, chi phí vượt gói và cơ chế điều chỉnh để doanh nghiệp dự toán được tổng chi phí sở hữu.",
        "Tham khảo: Cấu trúc gói dịch vụ GoPaperless Portal"
      ],
      "en": [
        "Short answer",
        "There is no single unit price suitable for every enterprise. Total cost depends on scope and transaction volume.",
        "Components that should be separated clearly",
        "Platform fees, administrator accounts or an enterprise package.",
        "Digital-signature, timestamp and data-message authentication fees.",
        "Identity-verification, VNeID or other third-party service fees where applicable.",
        "SMS, notification-channel, storage and overage charges.",
        "API integration, data conversion, training and SLA-based support fees.",
        "How GoPaperless pricing should be presented",
        "A sound proposal separates platform fees from third-party charges, states volume assumptions, explains re-signing and overage costs, and defines adjustment mechanisms so the enterprise can forecast its total cost of ownership.",
        "View details: GoPaperless Portal service-package structure"
      ]
    }
  },
  {
    "category": "solution",
    "number": "33",
    "question": {
      "vi": "Khi kết thúc dịch vụ, doanh nghiệp có thể mang toàn bộ dữ liệu và bằng chứng đi không?",
      "en": "When the service ends, can the enterprise take all of its data and evidence with it?"
    },
    "answerTemplate": "<h3>0</h3>\n<p><strong>1</strong>2</p>\n<h3>3</h3>\n<ul>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">8</div><p>9</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Đây phải là một điều kiện mua hàng bắt buộc.",
        " Doanh nghiệp cần giữ quyền tiếp cận, tải xuống và chuyển giao hồ sơ hợp pháp của mình.",
        "Gói bàn giao nên bao gồm",
        "File hợp đồng và tài liệu vòng đời.",
        "Thông tin chữ ký, chứng thư, dấu thời gian và chứng thực.",
        "Nhật ký giao dịch, ID, siêu dữ liệu và cấu trúc liên kết.",
        "Tài liệu mô tả định dạng và phương thức kiểm tra độc lập.",
        "GoPaperless",
        "Hỗ trợ tải xuống tài liệu và thao tác theo lô; với dự án doanh nghiệp, phạm vi xuất dữ liệu, định dạng và thời hạn chuyển giao được xác định trong hồ sơ giải pháp và hợp đồng dịch vụ."
      ],
      "en": [
        "Short answer",
        "This should be a mandatory procurement condition.",
        " The enterprise must retain the right to lawfully access, download and transfer its records.",
        "The handover package should include",
        "Contract files and lifecycle documents.",
        "Digital-signature, certificate, timestamp and authentication information.",
        "Transaction logs, IDs, metadata and link structures.",
        "Documentation describing the formats and methods for independent verification.",
        "GoPaperless",
        "GoPaperless supports document downloads and batch operations. For enterprise projects, the export scope, format and handover deadline are defined in the solution dossier and service contract."
      ]
    }
  },
  {
    "category": "solution",
    "number": "34",
    "question": {
      "vi": "GoPaperless khác gì so với công cụ ký PDF hoặc gửi OTP thông thường?",
      "en": "How is GoPaperless different from an ordinary PDF-signing or OTP-sending tool?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1<strong>2</strong>3</p>\n<div class=\"value-stack\">\n  <div><b>4</b><span>5</span></div>\n  <div><b>6</b><span>7</span></div>\n  <div><b>8</b><span>9</span></div>\n  <div><b>10</b><span>11</span></div>\n  <div><b>12</b><span>13</span></div>\n</div>\n<div class=\"key-point\"><strong>14</strong>15</div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Khác biệt nằm ở việc quản trị ",
        "toàn bộ giao dịch và vòng đời hồ sơ",
        ", không chỉ đặt một hình ảnh chữ ký lên PDF.",
        "1. Dữ liệu và quy trình",
        "Nhận dữ liệu từ nguồn, tạo mẫu, phê duyệt, ký theo thứ tự và xử lý theo lô.",
        "2. Định danh người ký",
        "Xác thực chủ thể bằng eID/VNeID hoặc phương thức phù hợp.",
        "3. Chữ ký và thời điểm",
        "Chữ ký số, chứng thư, dấu thời gian và chứng thực thông điệp dữ liệu theo cấu hình.",
        "4. Vòng đời và ID",
        "Liên kết hợp đồng, phụ lục, tạm hoãn, chấm dứt và theo dõi cấp ID.",
        "5. Bằng chứng và tích hợp",
        "Nhật ký, báo cáo, tìm kiếm, tải xuống và kết nối HRM/ERP.",
        "Giá trị thực:",
        " giảm thao tác thủ công, tăng khả năng kiểm soát và giúp doanh nghiệp chứng minh giao dịch khi cần."
      ],
      "en": [
        "Short answer",
        "The difference lies in managing ",
        "the entire transaction and record lifecycle",
        ", not merely placing a signature image on a PDF.",
        "1. Data and workflow",
        "Receive source data, generate documents from templates, obtain approvals, sign in sequence and process records in batches.",
        "2. Signer identification",
        "Authenticate the party through eID/VNeID or another appropriate method.",
        "3. Signature and time",
        "Apply digital signatures, certificates, timestamps and data-message authentication according to the configuration.",
        "4. Lifecycle and ID",
        "Link the contract, appendices, suspension and termination records and monitor ID issuance.",
        "5. Evidence and integration",
        "Provide logs, reports, search, download and HRM/ERP connectivity.",
        "Practical value:",
        " reduce manual work, improve control and help the enterprise prove the transaction when required."
      ]
    },
    "resources": [
      {
        "type": "file",
        "href": "https://drive.google.com/file/d/148AdE96kb2On9sIoU5pT-wQItwxl7nKM/view?usp=drive_link",
        "title": {
          "vi": "Tài liệu hướng dẫn (PDF)",
          "en": "Instruction guide (PDF)"
        },
        "description": {
          "vi": "Tài liệu so sánh GoPaperless với công cụ ký thông thường.",
          "en": "Document comparing GoPaperless with ordinary signing tools."
        }
      },
      {
        "type": "video",
        "href": "https://youtu.be/ESTTioFoI7I",
        "title": {
          "vi": "Video hướng dẫn",
          "en": "Instructional video"
        },
        "description": {
          "vi": "Video hướng dẫn giá trị và cách triển khai GoPaperless.",
          "en": "Video guide to GoPaperless value and deployment."
        }
      }
    ]
  },
  {
    "category": "solution",
    "number": "35",
    "question": {
      "vi": "Nếu một bộ phận người lao động không có smartphone, email hoặc VNeID thì triển khai thế nào?",
      "en": "How should deployment be handled if some employees do not have a smartphone, email address or VNeID account?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<h3>2</h3>\n<ul>\n  <li>3</li>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">7</div><p>8</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Không nên buộc toàn bộ người lao động đi qua một hành trình giống nhau. Doanh nghiệp cần phân nhóm và thiết kế tuyến ngoại lệ.",
        "Phương án triển khai",
        "Giữ hình thức giấy cho nhóm chưa đủ điều kiện điện tử trong giai đoạn chuyển đổi.",
        "Bố trí điểm hỗ trợ có kiểm soát tại nhà máy hoặc chi nhánh; hướng dẫn nhưng không làm thay người ký.",
        "Sử dụng phương thức định danh hoặc chữ ký số khác nếu pháp luật và dịch vụ cho phép.",
        "Ghi nhận lý do ngoại lệ và theo dõi kế hoạch chuyển đổi từng nhóm.",
        "GoPaperless",
        "Có thể cấu hình nhiều luồng theo nhóm người lao động, kênh mời ký và phương thức ký; quy trình ngoại lệ được quản lý riêng thay vì xử lý qua tin nhắn cá nhân."
      ],
      "en": [
        "Short answer",
        "The enterprise should not force every employee through the same journey. Employees should be segmented and an exception route should be designed.",
        "Deployment options",
        "Retain paper contracts for groups that are not yet ready for electronic execution during the transition.",
        "Establish controlled support points at factories or branches; personnel may guide employees but must not sign on their behalf.",
        "Use another identification or digital-signature method where permitted by law and supported by the service.",
        "Record the exception reason and monitor the transition plan for each group.",
        "GoPaperless",
        "Configure multiple workflows by employee group, invitation channel and signing method. Manage exception processes separately instead of handling them through personal messages."
      ]
    }
  },
  {
    "category": "solution",
    "number": "36",
    "question": {
      "vi": "Doanh nghiệp cần chuẩn bị gì để một buổi demo hoặc thử nghiệm GoPaperless phản ánh đúng thực tế?",
      "en": "What should an enterprise prepare so that a GoPaperless demo or pilot reflects real operations?"
    },
    "answerTemplate": "<h3>0</h3>\n<p>1</p>\n<h3>2</h3>\n<ul>\n  <li>3</li>\n  <li>4</li>\n  <li>5</li>\n  <li>6</li>\n  <li>7</li>\n</ul>\n<div class=\"solution-box compact\"><div class=\"solution-kicker\">8</div><p>9</p></div>",
    "answerTexts": {
      "vi": [
        "Trả lời ngắn",
        "Một buổi demo chỉ có giá trị khi sử dụng tình huống gần với vận hành thật của doanh nghiệp.",
        "Bộ dữ liệu nên chuẩn bị",
        "Một mẫu hợp đồng hoặc phụ lục đã ẩn thông tin nhạy cảm.",
        "Khoảng 10–30 dòng dữ liệu nhân sự mẫu.",
        "Sơ đồ người tạo, người duyệt, người ký và người theo dõi.",
        "Một vài tình huống lỗi: thiếu CCCD, sai email, người ký vắng mặt, người lao động không có VNeID.",
        "Yêu cầu tích hợp và tiêu chí thành công.",
        "Kết quả nên nhận được",
        "Một luồng hoàn chỉnh từ dữ liệu đến hợp đồng, báo cáo trạng thái, hồ sơ bằng chứng và danh sách khoảng cách cần xử lý trước khi triển khai chính thức."
      ],
      "en": [
        "Short answer",
        "A demo is only valuable when it uses a scenario close to the enterprise's actual operations.",
        "Recommended sample data",
        "One contract or appendix template with sensitive information removed.",
        "Approximately 10–30 rows of sample employee data.",
        "A map of document creators, approvers, signers and followers.",
        "Several error scenarios: missing citizen ID number, incorrect email address, absent signer or an employee without VNeID.",
        "Integration requirements and success criteria.",
        "Expected outcome",
        "A complete flow from data to contract, status reporting, an evidence package and a list of gaps to be addressed before production rollout."
      ]
    }
  }
];

export function renderFaqAnswer(item, lang) {
  const key = lang === "en" ? "en" : "vi";
  const parts = item.answerTexts[key] || item.answerTexts.vi;
  let html = item.answerTemplate;
  for (let i = 0; i < parts.length; i += 1) {
    html = html.split("" + i + "").join(parts[i]);
  }
  return html;
}

export function pickLang(value, lang) {
  if (value && typeof value === "object" && ("vi" in value || "en" in value)) {
    return lang === "en" ? value.en : value.vi;
  }
  return value;
}

export default faqItems;
